// !function(g){g.fn.twentytwenty=function(m){m=g.extend({default_offset_pct:.5,orientation:"horizontal"},m);return this.each(function(){var t=m.default_offset_pct,r=g(this),c=m.orientation,e="vertical"===c?"down":"left",n="vertical"===c?"up":"right";r.wrap("<div class='twentytwenty-wrapper twentytwenty-"+c+"'></div>"),r.append("<div class='twentytwenty-overlay'></div>");var s=r.find("img:first"),a=r.find("img:last");r.append("<div class='twentytwenty-handle'></div>");var u=r.find(".twentytwenty-handle");u.append("<span class='twentytwenty-"+e+"-arrow'></span>"),u.append("<span class='twentytwenty-"+n+"-arrow'></span>"),r.addClass("twentytwenty-container"),s.addClass("twentytwenty-before"),a.addClass("twentytwenty-after");var i=r.find(".twentytwenty-overlay");i.append("<div class='twentytwenty-before-label'></div>"),i.append("<div class='twentytwenty-after-label'></div>");function o(e){var t,n,a,i,o=(t=e,n=s.width(),a=s.height(),{w:n+"px",h:a+"px",cw:t*n+"px",ch:t*a+"px"});u.css("vertical"===c?"top":"left","vertical"===c?o.ch:o.cw),i=o,"vertical"===c?s.css("clip","rect(0,"+i.w+","+i.ch+",0)"):s.css("clip","rect(0,"+i.cw+","+i.h+",0)"),r.css("height",i.h)}g(window).on("resize.twentytwenty",function(e){o(t)});var l=0,d=0,f=0,p=0;u.on("movestart",function(e){((e.distX>e.distY&&e.distX<-e.distY||e.distX<e.distY&&e.distX>-e.distY)&&"vertical"!==c||(e.distX<e.distY&&e.distX<-e.distY||e.distX>e.distY&&e.distX>-e.distY)&&"vertical"===c)&&e.preventDefault(),r.addClass("active"),l=r.offset().left,d=r.offset().top,f=s.width(),p=s.height()}),u.on("moveend",function(e){r.removeClass("active")}),u.on("move",function(e){r.hasClass("active")&&((t="vertical"===c?(e.pageY-d)/p:(e.pageX-l)/f)<0&&(t=0),1<t&&(t=1),o(t))}),r.find("img").on("mousedown",function(e){e.preventDefault()}),g(window).trigger("resize.twentytwenty")})}}(jQuery),function(o){"use strict";o.fn.fitVids=function(e){var t,n,i={customSelector:null,ignore:null};return document.getElementById("fit-vids-style")||(t=document.head||document.getElementsByTagName("head")[0],(n=document.createElement("div")).innerHTML='<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>',t.appendChild(n.childNodes[1])),e&&o.extend(i,e),this.each(function(){var e=['iframe[src*="player.vimeo.com"]','iframe[src*="youtube.com"]','iframe[src*="youtube-nocookie.com"]','iframe[src*="kickstarter.com"][src*="video.html"]',"object","embed"];i.customSelector&&e.push(i.customSelector);var a=".fitvidsignore";i.ignore&&(a=a+", "+i.ignore);var t=o(this).find(e.join(","));(t=(t=t.not("object object")).not(a)).each(function(){var e,t,n=o(this);0<n.parents(a).length||"embed"===this.tagName.toLowerCase()&&n.parent("object").length||n.parent(".fluid-width-video-wrapper").length||(n.css("height")||n.css("width")||!isNaN(n.attr("height"))&&!isNaN(n.attr("width"))||(n.attr("height",9),n.attr("width",16)),e=("object"===this.tagName.toLowerCase()||n.attr("height")&&!isNaN(parseInt(n.attr("height"),10))?parseInt(n.attr("height"),10):n.height())/(isNaN(parseInt(n.attr("width"),10))?n.width():parseInt(n.attr("width"),10)),n.attr("name")||(t="fitvid"+o.fn.fitVids._count,n.attr("name",t),o.fn.fitVids._count++),n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",100*e+"%"),n.removeAttr("height").removeAttr("width"))})})},o.fn.fitVids._count=0}(window.jQuery||window.Zepto),function(e){"function"==typeof define&&define.amd?define([],e):"undefined"!=typeof module&&null!==module&&module.exports?module.exports=e:e()}(function(){function s(e){return e[$]||(e[$]={})}function a(e,t,n,a){function i(e){n(e,a)}t=t.split(z);for(var o,r=s(e),c=t.length;c--;)(r[o=t[c]]||(r[o]=[])).push([n,i]),e.addEventListener(o,i)}function r(e,t,n){t=t.split(z);var a,i,o,r=s(e),c=t.length;if(r)for(;c--;)if(i=r[a=t[c]])for(o=i.length;o--;)i[o][0]===n&&(e.removeEventListener(a,i[o][1]),i.splice(o,1))}function g(e,t,n){var a=new CustomEvent(t,j);n&&x(a,n),e.dispatchEvent(a)}function t(e){function t(e){a?(n(),k(t),a=!(i=!0)):i=!1}var n=e,a=!1,i=!1;this.kick=function(e){a=!0,i||t()},this.end=function(e){var t=n;e&&(i?(n=a?function(){t(),e()}:e,a=!0):e())}}function h(){}function c(e){e.preventDefault()}function u(e,t){var n,a;if(e.identifiedTouch)return e.identifiedTouch(t);for(n=-1,a=e.length;++n<a;)if(e[n].identifier===t)return e[n]}function l(e,t){var n=u(e.changedTouches,t.identifier);if(n&&(n.pageX!==t.pageX||n.pageY!==t.pageY))return n}function n(e,t){f(e,t,e,o)}function i(e,t){o()}function o(){r(document,A.move,n),r(document,A.cancel,i)}function d(e){r(document,C.move,e.touchmove),r(document,C.cancel,e.touchend)}function f(e,t,n,a){var i,o,r,c,s,u,l,d,f,p=n.pageX-t.pageX,m=n.pageY-t.pageY;p*p+m*m<X*X||(o=t,r=n,c=p,s=m,u=a,l=(i=e).targetTouches,d=i.timeStamp-o.timeStamp,f={altKey:i.altKey,ctrlKey:i.ctrlKey,shiftKey:i.shiftKey,startX:o.pageX,startY:o.pageY,distX:c,distY:s,deltaX:c,deltaY:s,pageX:r.pageX,pageY:r.pageY,velocityX:c/d,velocityY:s/d,identifier:o.identifier,targetTouches:l,finger:l?l.length:1,enableMove:function(){this.moveEnabled=!0,this.enableMove=h,i.preventDefault()}},g(o.target,"movestart",f),u(o))}function p(e,t){var n=t.timer;t.touch=e,t.timeStamp=e.timeStamp,n.kick()}function m(e,t){var n=t.target,a=t.event,i=t.timer;r(document,A.move,p),r(document,A.end,m),w(n,a,i,function(){setTimeout(function(){r(n,"click",c)},0)})}function v(e,t){var n,a=t.target,i=t.event,o=t.timer;u(e.changedTouches,i.identifier)&&(n=t,r(document,C.move,n.activeTouchmove),r(document,C.end,n.activeTouchend),w(a,i,o))}function w(e,t,n,a){n.end(function(){return g(e,"moveend",t),a&&a()})}function e(e){e.enableMove()}function y(e){e.enableMove()}function b(e){e.enableMove()}function _(e){var a=e.handler;e.handler=function(e){for(var t,n=Y.length;n--;)e[t=Y[n]]=e.originalEvent[t];a.apply(this,arguments)}}var Y,x=Object.assign||window.jQuery&&jQuery.extend,X=8,k=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e,t){return window.setTimeout(function(){e()},25)},T={textarea:!0,input:!0,select:!0,button:!0},A={move:"mousemove",cancel:"mouseup dragstart",end:"mouseup"},C={move:"touchmove",cancel:"touchend",end:"touchend"},z=/\s+/,j={bubbles:!0,cancelable:!0},$=Symbol("events");a(document,"mousedown",function(e){var t;1!==(t=e).which||t.ctrlKey||t.altKey||(T[e.target.tagName.toLowerCase()]||(a(document,A.move,n,e),a(document,A.cancel,i,e)))}),a(document,"touchstart",function(e){var t,n;T[e.target.tagName.toLowerCase()]||(n={target:(t=e.changedTouches[0]).target,pageX:t.pageX,pageY:t.pageY,identifier:t.identifier,touchmove:function(e,t){var n,a,i;(i=l(n=e,a=t))&&f(n,a,i,d)},touchend:function(e,t){var n;n=t,u(e.changedTouches,n.identifier)&&d(n)}},a(document,C.move,n.touchmove,n),a(document,C.cancel,n.touchend,n))}),a(document,"movestart",function(e){var o,r;!e.defaultPrevented&&e.moveEnabled&&(o={startX:e.startX,startY:e.startY,pageX:e.pageX,pageY:e.pageY,distX:e.distX,distY:e.distY,deltaX:e.deltaX,deltaY:e.deltaY,velocityX:e.velocityX,velocityY:e.velocityY,identifier:e.identifier,targetTouches:e.targetTouches,finger:e.finger},r={target:e.target,event:o,timer:new t(function(e){var t,n,a,i;t=o,n=r.touch,a=r.timeStamp,i=a-t.timeStamp,t.distX=n.pageX-t.startX,t.distY=n.pageY-t.startY,t.deltaX=n.pageX-t.pageX,t.deltaY=n.pageY-t.pageY,t.velocityX=.3*t.velocityX+.7*t.deltaX/i,t.velocityY=.3*t.velocityY+.7*t.deltaY/i,t.pageX=n.pageX,t.pageY=n.pageY,g(r.target,"move",o)}),touch:void 0,timeStamp:e.timeStamp},void 0===e.identifier?(a(e.target,"click",c),a(document,A.move,p,r),a(document,A.end,m,r)):(r.activeTouchmove=function(e,t){var n,a,i,o,r;n=e,i=(a=t).event,o=a.timer,(r=l(n,i))&&(n.preventDefault(),i.targetTouches=n.targetTouches,a.touch=r,a.timeStamp=n.timeStamp,o.kick())},r.activeTouchend=function(e,t){v(e,t)},a(document,C.move,r.activeTouchmove,r),a(document,C.end,r.activeTouchend,r)))}),window.jQuery&&(Y="startX startY pageX pageY distX distY deltaX deltaY velocityX velocityY".split(" "),jQuery.event.special.movestart={setup:function(){return a(this,"movestart",e),!1},teardown:function(){return r(this,"movestart",e),!1},add:_},jQuery.event.special.move={setup:function(){return a(this,"movestart",y),!1},teardown:function(){return r(this,"movestart",y),!1},add:_},jQuery.event.special.moveend={setup:function(){return a(this,"movestart",b),!1},teardown:function(){return r(this,"movestart",b),!1},add:_})}),function(e){"function"==typeof define&&define.amd?define([],e):"undefined"!=typeof module&&null!==module&&module.exports?module.exports=e:e()}(function(){function s(e){return e[$]||(e[$]={})}function a(e,t,n,a){function i(e){n(e,a)}t=t.split(z);for(var o,r=s(e),c=t.length;c--;)(r[o=t[c]]||(r[o]=[])).push([n,i]),e.addEventListener(o,i)}function r(e,t,n){t=t.split(z);var a,i,o,r=s(e),c=t.length;if(r)for(;c--;)if(i=r[a=t[c]])for(o=i.length;o--;)i[o][0]===n&&(e.removeEventListener(a,i[o][1]),i.splice(o,1))}function g(e,t,n){var a=new CustomEvent(t,j);n&&x(a,n),e.dispatchEvent(a)}function t(e){function t(e){a?(n(),k(t),a=!(i=!0)):i=!1}var n=e,a=!1,i=!1;this.kick=function(e){a=!0,i||t()},this.end=function(e){var t=n;e&&(i?(n=a?function(){t(),e()}:e,a=!0):e())}}function h(){}function c(e){e.preventDefault()}function u(e,t){var n,a;if(e.identifiedTouch)return e.identifiedTouch(t);for(n=-1,a=e.length;++n<a;)if(e[n].identifier===t)return e[n]}function l(e,t){var n=u(e.changedTouches,t.identifier);if(n&&(n.pageX!==t.pageX||n.pageY!==t.pageY))return n}function i(e,t){f(e,t,e,n)}function o(e,t){n()}function n(){r(document,A.move,i),r(document,A.cancel,o)}function d(e){r(document,C.move,e.touchmove),r(document,C.cancel,e.touchend)}function f(e,t,n,a){var i,o,r,c,s,u,l,d,f,p=n.pageX-t.pageX,m=n.pageY-t.pageY;p*p+m*m<X*X||(o=t,r=n,c=p,s=m,u=a,l=(i=e).targetTouches,d=i.timeStamp-o.timeStamp,f={altKey:i.altKey,ctrlKey:i.ctrlKey,shiftKey:i.shiftKey,startX:o.pageX,startY:o.pageY,distX:c,distY:s,deltaX:c,deltaY:s,pageX:r.pageX,pageY:r.pageY,velocityX:c/d,velocityY:s/d,identifier:o.identifier,targetTouches:l,finger:l?l.length:1,enableMove:function(){this.moveEnabled=!0,this.enableMove=h,i.preventDefault()}},g(o.target,"movestart",f),u(o))}function p(e,t){var n=t.timer;t.touch=e,t.timeStamp=e.timeStamp,n.kick()}function m(e,t){var n=t.target,a=t.event,i=t.timer;r(document,A.move,p),r(document,A.end,m),w(n,a,i,function(){setTimeout(function(){r(n,"click",c)},0)})}function v(e,t){var n,a=t.target,i=t.event,o=t.timer;u(e.changedTouches,i.identifier)&&(n=t,r(document,C.move,n.activeTouchmove),r(document,C.end,n.activeTouchend),w(a,i,o))}function w(e,t,n,a){n.end(function(){return g(e,"moveend",t),a&&a()})}function e(e){e.enableMove()}function y(e){e.enableMove()}function b(e){e.enableMove()}function _(e){var a=e.handler;e.handler=function(e){for(var t,n=Y.length;n--;)e[t=Y[n]]=e.originalEvent[t];a.apply(this,arguments)}}var Y,x=Object.assign||window.jQuery&&jQuery.extend,X=8,k=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e,t){return window.setTimeout(function(){e()},25)},T={textarea:!0,input:!0,select:!0,button:!0},A={move:"mousemove",cancel:"mouseup dragstart",end:"mouseup"},C={move:"touchmove",cancel:"touchend",end:"touchend"},z=/\s+/,j={bubbles:!0,cancelable:!0},$=Symbol("events");a(document,"mousedown",function(e){var t,n;1!==(n=e).which||n.ctrlKey||n.altKey||((t=e).target&&T[t.target.tagName.toLowerCase()]||(a(document,A.move,i,e),a(document,A.cancel,o,e)))}),a(document,"touchstart",function(e){var t,n;T[e.target.tagName.toLowerCase()]||(n={target:(t=e.changedTouches[0]).target,pageX:t.pageX,pageY:t.pageY,identifier:t.identifier,touchmove:function(e,t){var n,a,i;(i=l(n=e,a=t))&&f(n,a,i,d)},touchend:function(e,t){var n;n=t,u(e.changedTouches,n.identifier)&&d(n)}},a(document,C.move,n.touchmove,n),a(document,C.cancel,n.touchend,n))}),a(document,"movestart",function(e){var o,r;!e.defaultPrevented&&e.moveEnabled&&(o={startX:e.startX,startY:e.startY,pageX:e.pageX,pageY:e.pageY,distX:e.distX,distY:e.distY,deltaX:e.deltaX,deltaY:e.deltaY,velocityX:e.velocityX,velocityY:e.velocityY,identifier:e.identifier,targetTouches:e.targetTouches,finger:e.finger},r={target:e.target,event:o,timer:new t(function(e){var t,n,a,i;t=o,n=r.touch,a=r.timeStamp,i=a-t.timeStamp,t.distX=n.pageX-t.startX,t.distY=n.pageY-t.startY,t.deltaX=n.pageX-t.pageX,t.deltaY=n.pageY-t.pageY,t.velocityX=.3*t.velocityX+.7*t.deltaX/i,t.velocityY=.3*t.velocityY+.7*t.deltaY/i,t.pageX=n.pageX,t.pageY=n.pageY,g(r.target,"move",o)}),touch:void 0,timeStamp:e.timeStamp},void 0===e.identifier?(a(e.target,"click",c),a(document,A.move,p,r),a(document,A.end,m,r)):(r.activeTouchmove=function(e,t){var n,a,i,o,r;n=e,i=(a=t).event,o=a.timer,(r=l(n,i))&&(n.preventDefault(),i.targetTouches=n.targetTouches,a.touch=r,a.timeStamp=n.timeStamp,o.kick())},r.activeTouchend=function(e,t){v(e,t)},a(document,C.move,r.activeTouchmove,r),a(document,C.end,r.activeTouchend,r)))}),window.jQuery&&(Y="startX startY pageX pageY distX distY deltaX deltaY velocityX velocityY".split(" "),jQuery.event.special.movestart={setup:function(){return a(this,"movestart",e),!1},teardown:function(){return r(this,"movestart",e),!1},add:_},jQuery.event.special.move={setup:function(){return a(this,"movestart",y),!1},teardown:function(){return r(this,"movestart",y),!1},add:_},jQuery.event.special.moveend={setup:function(){return a(this,"movestart",b),!1},teardown:function(){return r(this,"movestart",b),!1},add:_})}),function(e){var t="function"==typeof define&&define.amd&&(define(["jquery"],e)||!0),n=!t&&"object"==typeof module&&"object"==typeof module.exports&&(module.exports=e);t||n||e()}(function(){return jQuery.reel||function(N,Q,e,K){function L(e){return J.instances.first().data(e)}function R(e){return"<"+e+"/>"}function M(e){return"."+(e||"")}function O(e){return e.replace(m,J.cdn)}function P(e){return"url('"+W(e)+"')"}function B(e,t){return typeof t==on?t[e]:t}function c(e,t,n){return ve(e,he(t,n))}function H(e,t){return we(e)*(t?-1:1)}function V(e){return e.touch||e.originalEvent.touches&&e.originalEvent.touches[0]||e}function U(e){return e.originalEvent}function Z(e){return e===K?0:typeof e==rn?e:e+"px"}function G(e){return"#"+e}function f(e,t,n){for(;e.length<t;)e=n+e;return e}function t(e){return f(e,2,"0")}function W(e){return encodeURI(decodeURI(e))}function r(e){return J.re.array.exec(e)?e.split(J.re.array):e}function s(n){return typeof n==rn?n:N.each(n,function(e,t){n[e]=t?+t:K})}function u(e){try{console.error("[ Reel ] "+e)}catch(e){}}if(N){var n=N&&N().jquery.split(/\./);if(!n||+(t(n[0])+t(n[1])+t(n[2]||""))<10602)return u("Too old jQuery library. Please upgrade your jQuery to version 1.6.2 or higher");var l,J=N.reel={version:"1.3.0",def:{frame:1,frames:36,loops:!0,clickfree:!1,draggable:!0,scrollable:!0,steppable:!0,throwable:!0,wheelable:!0,orientable:!1,cw:!1,revolution:K,stitched:0,directional:!1,row:1,rows:0,rowlock:!1,framelock:!1,orbital:0,vertical:!1,inversed:!1,footage:6,spacing:0,horizontal:!0,suffix:"-reel",image:K,images:"",path:"",preload:"fidelity",shy:!1,speed:0,delay:0,timeout:2,duration:K,rebound:.5,entry:K,opening:0,brake:.23,velocity:0,tempo:36,laziness:6,cursor:K,hint:"",indicator:0,klass:"",preloader:2,area:K,attr:{},annotations:K,responsive:!1,graph:K,monitor:K},scan:function(){return N(M(ne)+":not("+M(ae)+" > "+M(ne)+")").each(function(e,t){var n=N(t),a=n.data(),o=(a.images=r(a.images),{});N(M(se)+"[data-for="+n.attr(tn)+"]").each(function(e,t){var n=N(t),a=n.data(),i=(a.x=s(r(a.x)),a.y=s(r(a.y)),n.attr(tn));a.node=n.removeData(),o[i]=a}),a.annotations=o,n.removeData().reel(a)})},fn:{reel:function(){var e=arguments,t=N(this),n=t.data(),a=e[0]||{},i=e[1];if("object"!=typeof a)return":"==a.slice(0,1)?t.trigger(a.slice(1),i):1==e.length?n[a]:(i!==K&&(J.normal[a]&&(i=J.normal[a](i,n)),n[a]===K?n[a]=i:n[a]!==i&&t.trigger(a+"Change",[K,n[a]=i])),t);var F=N.extend({},J.def,a),o=t.filter(nn).unreel().filter(function(){var e=N(this),t=F.attr,n=t.src||e.attr(ht),a=t.width||e.attr(Be)||e.width(),i=t.height||e.attr(zt)||e.height();return n?!(!a||!i)||u("Dimension(s) of the target image unknown"):u("`src` attribute missing on target image")}),I=[];return o.each(function(){function T(e,t){return A.reel(e,t)&&C(e)}var s,a,i,A=N(this),C=function(e){return A.data(e)},z={setup:function(e){var t,n,a,i,o,r,c,s,u,l,d,f,p,m,g,h,v,w,y,b,_,Y,x,X,k;A.hasClass(ne)&&A.parent().hasClass(ae)||(T(tt,F),t={src:A.attr(ht),width:A.attr(zt)||null,height:A.attr(Be)||null,style:A.attr(Yt)||null,class:A.attr($e)||null},n=A.attr(F.attr).attr(ht),a=T(tn,A.attr(tn)||A.attr(tn,ne+"-"+ +new Date).attr(tn)),i=N.extend({},A.data()),o=T(Ze,F.images||[]),r=T(wt,F.stitched),c=!o.length||r,s=T(ct,F.responsive&&(!!te||!c)),u=T(Tt,{}),l=F.loops,d=F.orbital,f=F.revolution,y=F.rows,p=T(Le,he(F.footage,F.frames)),T(mt,F.spacing),m=T(zt,+A.attr(zt)||A.width()),g=T(Be,+A.attr(Be)||A.height()),h=T(pt,F.shy),v=T(Pe,d&&p||y<=1&&o.length||F.frames),w=1<y||d,T(st,B("x",f)||r/2||2*m),T(ut,w?B("y",f)||(3<y?g:g/(5-y)):0),y=r?1:ge(v/p),T(bt,r-(l?0:m)),T(yt,0),b=G(a+F.suffix),Y=(_=A.attr($e))?_+Ht:Bt,X=N(R(Gt),{id:b.substr(1),class:Y+Ht+ae+Ht+de+"0"}),x=A.wrap(X.addClass(F.klass)).addClass(ne),I.push((k=x,J.instances.push(k[0])&&k)[0]),X=x.parent().bind(z.instance),T(Ue,o.length?Bt:F.image||n.replace(J.re.image,"$1"+F.suffix+".$2")),T(Ce,N(R(Gt),{class:ie}).appendTo("body")),T(Ye,N()),T(ze,[]),T(Me,null),T(Re,null),T(lt,F.row),T(kt,0),T(ft,y),T(dt,F.rowlock),T(Oe,F.framelock),T(Ne,T(Qe,T(Ke,0))),T(Te,1/v),T(vt,b),T(ke,T(gt,F.speed)<0),T(We,!1),T(At,0),T(Ct,F.vertical),T(at,0),T(Ie,H(1,!F.cw&&!r)),T(De,{}),T(qe,!1),T(Ee,T(Fe,0)),T(Ge,T(He,0)),T(ot,!1),T(rt,!1),T(Je,!1),T(Ae,F.brake),T(je,!!d),T(xt,F.tempo/(J.lazy?F.laziness:1)),T(et,-1),T(Xt,-1),T(_e,F.annotations||X.unbind(M(_e))&&{}),T(it,1),T(Xe,{attr:t,data:i}),F.steppable||X.unbind("up.steppable"),F.indicator||X.unbind(".indicator"),j(Bt,{overflow:Ve,position:"relative"}),s||j(Bt,{width:m,height:g}),s&&N.each(cn,function(e,t){u[t]=C(t)}),j(Vt+Ht+M(ne),{display:Zt}),j(M(ie),{position:"fixed",left:Z(-100),top:Z(-100)},!0),j(M(ie)+Ht+nn,{position:Ut,width:10,height:10},!0),ee.bind(z.pool),A.trigger(h?"prepare":"setup"))},instance:{teardown:function(e){var t,n=A.data(Xe);A.parent().unbind(z.instance),C(pt)?A.parent().unbind(Se,l):C(Yt).remove()&&C(Ye).unbind(jt),C(Ce).empty(),clearTimeout(a),clearTimeout(i),N(Q).unbind(Pt,k),N(Q).unbind(jt),ee.unbind(z.pool),E.unbind($t),A.siblings().unbind(jt).remove(),Y(),A.removeAttr("onloaded"),t=A.unbind(jt).removeData().unwrap().attr(n.attr).data(n.data),J.instances=J.instances.not(G(t.attr(tn))),A.attr(Yt)==Bt&&A.removeAttr(Yt)},setup:function(e){function t(e){return A.trigger("down",[V(e).clientX,V(e).clientY,e])&&e.give}var n=A.parent().append(m()),a=T(Ye,N(F.area||n)),i=1<F.rows,o=F.cursor,r=o==Wt?ln:o||un,c=o==Wt?dn+Ht+"!important":K;j(Ht+M(ne),{MozUserSelect:an,WebkitUserSelect:an,MozTransform:"translateZ(0)"}),A.unbind(Se,l),a.bind(Mt,t).bind(F.clickfree?Et:Dt,t).bind(F.wheelable?Qt:null,function(e,t){return!t||A.trigger("wheel",[t,e])&&e.give}).bind(qt,function(){return!1}),j(Bt,{cursor:O(r)}),j(M(le),{cursor:"wait"}),j(M(ue)+Vt+M(ue)+" *",{cursor:O(c||r)},!0),C(ct)&&(j(Ht+M(ne),{width:"100%",height:xe}),N(Q).bind(Pt,k)),F.hint&&a.attr("title",F.hint),F.indicator&&n.append(g("x")),i&&F.indicator&&n.append(g("y")),F.monitor&&n.append(p=N(R(Gt),{class:ce}))&&j(Ht+M(ce),{position:Ut,left:0,top:0})},preload:function(e){function t(){var e=s.children(":not([src]):first");return e.attr(ht,e.data(ht))}var n=A.parent(),a=C(Ze),i=!a.length,o=J.preload[F.preload]||J.preload[J.def.preload],r=i?[C(Ue)]:o(a.slice(0),F,C),c=(r.length,T(at,i?.5:0),0),s=C(Ce).empty(),u=[];for(n.addClass(le),T(Yt,C(Yt)||N("<"+Yt+' type="text/css">'+j.rules.join("\n")+"</"+Yt+">").prependTo(Jt)),T(We,!0),A.trigger("stop"),F.responsive&&$(),A.trigger("resize",!0);r.length;){var l=J.substitute(F.path+r.shift(),C);N(R(nn)).data(ht,l).appendTo(s).bind("load error abort",function(e){return"load"!=e.type&&A.trigger(e.type),!!n.parents(en).length&&A.trigger("preloaded")&&t()&&!1}),u.push(l)}setTimeout(function(){for(;++c<J.concurrent_requests;)t()},0),T(ze,u),T(pt,!1)},preloaded:function(e){var t=C(Ze).length||1,n=T(at,he(C(at)+1,t));1===n&&A.trigger("frameChange",[K,C(Me)]),n===t&&(A.parent().removeClass(le),A.trigger("loaded"))},loaded:function(e){1<C(Ze).length||A.css({backgroundImage:P(J.substitute(F.path+C(Ue),C))}).attr({src:O(sn)}),C(wt)&&A.attr({src:O(sn)}),C(rt)||T(At,F.velocity||0),T(We,!1),o=!0},prepare:function(e){A.css("display",Zt).parent().one(Se,l)},opening:function(e){if(!F.opening)return A.trigger("openingDone");var t=(T(Je,!0),T(_t,!C(gt)),F.entry||F.speed),n=C(Re),a=F.opening;T(Re,n-t*a),T(et,ge(a*L(xt)))},openingDone:function(e){var t=(T(nt,!1),T(Je,!1),Kt+M(Je));ee.unbind(t,z.pool[t]),F.orientable&&N(Q).bind(St,function(e){return A.trigger("orient",[U(e).alpha,U(e).beta,U(e).gamma,e])&&e.give}),0<F.delay?a=setTimeout(function(){A.trigger("play")},1e3*F.delay):A.trigger("play")},play:function(e,t){var t=t?T(gt,t):C(gt)*H(1,C(ke)),n=F.duration,a=(n&&T(Xt,ge(n*L(xt))),T(ke,t<0),T(nt,!!t));T(_t,!a),r()},reach:function(e,t,n){var a,i,o;t!=C(Me)&&(a=C(Pe),T(lt,ge(t/a)),i=T(Ne,C(Me)),t=T(Qe,t),o=T(Ke,J.math.distance(i,t,a)),n=we(n||C(gt))*H(1,o<0),A.trigger("play",n))},pause:function(e){v()},stop:function(e){var t=T(_t,!0);T(nt,!t)},down:function(e,t,n,a){function i(e){return A.trigger("up",[e])&&e.give}var o,r;!F.clickfree&&a&&a.button!==K&&a.button!=fn||!F.draggable||(T(qe,C(Me)),o=F.clickfree,T(At,0),r=o?C(Ye):E,b=S(C(st),t,n),v(),Y(),w=0,N(en,E).addClass(ue),r.bind(Ot+Ht+It,function(e){return A.trigger("pan",[V(e).clientX,V(e).clientY,e])&&e.give}).bind(Rt+Ht+Lt,i).bind(o?Ft:Nt,i))},up:function(e,t){var n=(T(qe,!1),T(ot,!1),F.throwable),a=we(x[0]+x[1])/60,i=T(At,n?!0===n?a:he(n,a):0);d=i?1:0,v(),Y(),N(en,E).removeClass(ue),(F.clickfree?C(Ye):E).unbind($t)},pan:function(e,t,n,a){if(F.draggable&&q){q=!1,v();var i,o,r,c,s,u,l,d,f=F.rows,p=F.orbital,m=!C(ot)&&f<=1&&!p&&F.scrollable,g={x:t-b.x,y:n-b.y},h={x:we(g.x),y:we(g.y)};if(a&&m&&h.x<h.y)return a.give=!0;(0<h.x||0<h.y)&&(a&&(a.give=!1),w=ve(h.x,h.y),b={x:t,y:n},i=C(st),d=C(De),c=C(Ct),C(Oe)||(o=T(Re,X(c?n-d.y:t-d.x,C(Ee),i,C(Ge),C(He),C(Ie),c?n-d.y:t-d.x)),T(ot,C(ot)||C(Me)!=C(qe)),(r=_(c?g.y:g.x||0))&&T(ke,r<0)),p&&C(je)&&(c=T(Ct,we(n-d.y)>we(t-d.x)),d=S(i,t,n)),1<f&&!C(dt)&&(s=C(ut),l=-(u=C(Fe))*s,T(kt,J.math.envelope(n-d.y,u,s,l,l+s,-1))),o%1||F.loops||(d=S(i,t,n)))}},wheel:function(e,t,n){var a,i;t&&(c=!0,a=H(a=ge(fe.sqrt(we(t))/2),0<t),i=.0833*C(st),S(i),a&&T(ke,a<0),T(At,0),T(Re,X(a,C(Ee),i,C(Ge),C(He),C(Ie))),n&&n.preventDefault(),n&&(n.give=!1),v(),A.trigger("up",[n]))},orient:function(e,t,n,a,i){var o;q&&!s&&(f=!0,o=t/360,fraction=T(Re,+(F.stitched||F.cw?1-o:o).toFixed(2)),q=!1)},fractionChange:function(e,t,n){var a,i,o;t===K&&(o=1+me(n/C(Te)),a=1<F.rows,i=F.orbital,T(je,!!i&&(o<=i||o>=C(Le)-i+2)),a&&(o+=(C(lt)-1)*C(Pe)),o=T(Me,o))},tierChange:function(e,t,n){var a,i,o;t===K&&(a=T(lt,pe(be(n,1,F.rows))),i=C(Pe),o=C(Me)%i||i,o=T(Me,o+a*i-i))},rowChange:function(e,t,n){t===K&&D(kt,K,n,F.rows)},frameChange:function(e,t,n){var a,i,o,r,c,s,u,l,d,f,p,m,g,h,v,w,y,b,_,Y;t===K&&(this.className=this.className.replace(J.re.frame_klass,de+n),a=C(Pe),i=F.rows,o=F.path,c=((n-(r=n%a||a))/a+1-1)/(i-1),s=C(lt),i?D(kt,c,s,i):C(kt),u=D(Re,K,r,a),l=C(Le),F.orbital&&C(Ct)&&(n=F.inversed?l+1-n:n,n+=l),d=C(wt),!(f=C(Ze)).length||d?(p=C(mt),m=C(zt),g=C(Be),d?(Y=[Z(-T(yt,pe(be(u,0,C(bt)))%d)),Z(-(i<=1?0:(g+p)*(i-s)))],h=1<f.length&&f[s-1],v=J.substitute(o+h,C),h&&A.css("backgroundImage").search(v)<0&&A.css({backgroundImage:P(v)})):(w=F.horizontal,y=(y=n%l-1)<0?l-1:y,b=(me((n-.1)/l)+(!(1<i)&&!C(ke)&&F.directional?C(ft):0))*((w?g:m)+p),_=y*((w?m:g)+p),Y=f.length?[0,0]:w?[Z(-_),Z(-b)]:[Z(-b),Z(-_)]),A.css({backgroundPosition:Y.join(Ht)})):(C(ct)&&$(),C(at)&&A.attr({src:W(J.substitute(o+f[n-1],C))})))},"frameChange.reach":function(e,t,n){var a;C(Qe)&&t===K&&(a=J.math.distance(C(Ne),n,C(Pe)),we(a)>=we(C(Ke))&&(T(Me,T(Qe)),T(Qe,T(Ke,T(Ne,0))),A.trigger("stop")))},"imageChange imagesChange":function(e,t,n){A.trigger("preload")},"fractionChange.indicator":function(e,t,n){var a,i,o,r,c,s;F.indicator&&t===K&&(a=F.indicator,i=F.orbital,c=C(i&&C(Ct)?Be:zt),o=i?C(Le):F.images.length||C(Pe),r=ge(c/o),s=pe(be(n,0,c=c-r)),s=!F.cw||C(wt)?s:c-s,g.$x.css(C(Ct)?{left:0,top:Z(s),bottom:xe,width:a,height:r}:{bottom:0,left:Z(s),top:xe,width:r,height:a}))},"tierChange.indicator":function(e,t,n){var a,i,o,r;1<F.rows&&F.indicator&&t===K&&(o=C(Be),a=F.indicator,i=ge(o/F.rows),r=pe(n*(o=o-i)),g.$y.css({left:0,top:r,width:a,height:i}))},"setup.annotations":function(e){var o=A.parent();N.each(C(_e),function(e,t){var n=(n=(n=typeof t.node==rn?N(t.node):t.node||{}).jquery?n:N(R(Gt),n)).attr({id:e}).addClass(se),a=t.image?N(R(nn),t.image):N(),i=t.link?N("<a/>",t.link).click(function(){A.trigger("up.annotations",{target:i})}):N();j(G(e),{display:an,position:Ut},!0),t.image||t.link&&n.append(i),t.link||t.image&&n.append(a),t.link&&t.image&&n.append(i.append(a)),n.appendTo(o)})},"prepare.annotations":function(e){N.each(C(_e),function(e,t){N(G(e)).hide()})},"frameChange.annotations":function(e,t,n){var m,g,h;C(at)&&t===K&&(m=C(zt),g=C(wt),h=C(yt),N.each(C(_e),function(e,t){var n,a,i=N(G(e)),o=t.start||1,r=t.end,c=c||C(Me),s=c-1,u=!!t.at&&"+"==t.at[s],s=t.at?s:s-o+1,l=typeof t.x!=on?t.x:t.x[s],d=typeof t.y!=on?t.y:t.y[s],f=l!==K&&d!==K&&(t.at?u:0<=s&&(!r||s<=r-o));g&&(n=g-m<l&&0<=h&&h<m,l=l<m&&g-m<h?l+g:l,l=n?l-g:l,l-=h),C(ct)&&(a=C(it),l=l&&l*a,d=d&&d*a);var p={display:f?Zt:an,left:Z(l),top:Z(d)};i.css(p)}))},"up.annotations":function(e,t){var n;10<w||c||((n=N(t.target)).is("a")?n:n.parents("a")).attr("href")&&(w=10)},"up.steppable":function(e,t){w||c||A.trigger(C(De).x-A.offset().left>.5*C(zt)?"stepRight":"stepLeft")},"stepLeft stepRight":function(e){v()},stepLeft:function(e){T(ke,!1),T(Re,C(Re)-C(Te)*C(Ie))},stepRight:function(e){T(ke,!0),T(Re,C(Re)+C(Te)*C(Ie))},stepUp:function(e){T(lt,C(lt)-1)},stepDown:function(e){T(lt,C(lt)+1)},resize:function(e,t){var n,a,i,o,r,c;C(We)&&!t||(n=C(wt),a=C(mt),i=C(Be),o=!C(Ze).length||n,r=F.rows||1,c=C(Ze).length?n?Z(n)+Ht+Z(i):K:n&&Z(n)+Ht+Z((i+a)*r-a)||Z((C(zt)+a)*C(Le)-a)+Ht+Z((i+a)*C(ft)*r*(F.directional?2:1)-a),A.css({height:o?Z(i):null,backgroundSize:c||null}),t||A.trigger("imagesChange"))},"setup.fu":function(e){T(Me,F.frame+(C(lt)-1)*C(Pe)),A.trigger("preload")},"wheel.fu":function(){c=!1},"clean.fu":function(){A.trigger("teardown")},"loaded.fu":function(){A.trigger("opening")}},pool:{"tick.reel.preload":function(e){var t,n,a,i;!o&&!C(We)||C(pt)||(t=C(zt),n=ye(m.$.css(zt)),a=C(Ze).length||1,i=pe(1/a*C(at)*t),m.$.css({width:n+(i-n)/3+1}),C(at)===a&&t-1<n&&(o=!1,m.$.fadeOut(300,function(){m.$.css({opacity:1,width:0})})))},"tick.reel":function(e){if(!C(pt)){var t,n,a,i,o=C(At),r=L(xt),c=F.monitor;if(J.intense||!h()){if(d&&(t=o-C(Ae)/r*d,o=T(At,.1<t?t:d=s=0)),c&&p.text(C(c)),o&&d++,s&&s++,_(0),q=!0,s&&!o)return u(e);if(C(qe))return u(e,v());0<C(et)||(!F.loops&&F.rebound&&(s||C(Re)%1?y=0:y++,y>=1e3*F.rebound/r)&&T(ke,!C(ke)),n=C(Ie)*H(1,C(ke)),i=C(Xt),a=(C(nt)&&!f&&i?we(C(gt))+o:o)/L(xt),!(i=(T(Re,C(Re)-a*n),F.duration?0<i&&T(Xt,i-1):i))&&C(nt)&&A.trigger("stop"))}}},"tick.reel.opening":function(e){var t,n;C(Je)&&(t=(F.entry||F.speed)/L(xt)*(F.cw?-1:1),n=T(et,C(et)-1),T(Re,C(Re)+t),n||A.trigger("openingDone"))}}},o=!1,u=function(e,t){return e.stopImmediatePropagation()||t},l=function(){A.trigger("setup")},d=0,r=function(){return s=0},v=function(){return clearTimeout(a),ee.unbind(Kt+M(Je),z.pool[Kt+M(Je)]),T(et,0),T(rt,!0),s=-F.timeout*L(xt)},w=0,c=!1,f=!1,p=N(),m=function(){return j(Ht+M(re),{position:Ut,left:0,bottom:0,height:F.preloader,overflow:Ve,backgroundColor:"#000"}),m.$=N(R(Gt),{class:re})},g=function(e){return j(Ht+M(oe)+M(e),{position:Ut,width:0,height:0,overflow:Ve,backgroundColor:"#000"}),g["$"+e]=N(R(Gt),{class:oe+Ht+e})},j=function(e,t,n){var a,i=n?Bt:C(vt),e=e.replace(/^/,i).replace(Vt,Vt+i);return j.rules.push(e+(a=[],N.each(t,function(e,t){a.push(e.replace(/([A-Z])/g,"-$1").toLowerCase()+":"+Z(t)+";")}),"{"+a.join(Bt)+"}"))&&t},h=function(){var e=C(Be),t=C(zt),n=A[0].getBoundingClientRect();return n.top<-e||n.left<-t||n.right>t+N(Q).width()||n.bottom>e+N(Q).height()},y=0,b={x:0,y:0},_=function(e){return x.push(e)&&x.shift()&&e},Y=function(){return x=[0,0]},x=Y(),X=F.graph||J.math[F.loops?"hatch":"envelope"],k=(J.normal,function(){clearTimeout(i),i=setTimeout($,J.resize_gauge)}),$=function(){var e,n;A.width()!=C(zt)&&(e=C(Tt),n=T(it,A.width()/e.width),N.each(e,function(e,t){T(e,pe(t*n))}),A.trigger("resize"))},S=function(e,t,n){var a=T(Ee,C(Re)),i=(T(Fe,C(kt)),F.loops);return T(Ge,i?0:-a*e),T(He,i?e:e-a*e),t!==K&&T(De,{x:t,y:n})||K},q=!0,D=function(e,t,n,a){if(a){var i=C(e)||0,o=t!==K?t:(n-1)/(a-1),o=e!=Re?o:he(o,.9999);return t=+we(i-o).toFixed(8)>=+(1/(a-1)).toFixed(8)?T(e,o):t||i}},E=ee;try{ee[0]!=top.document&&(E=ee.add(top.document))}catch(e){}top===self?N():N("iframe",E.last()).each(function(){try{if(N(this).contents().find(Jt).html()==N(Jt).html())return N(this)&&!1}catch(e){}}),j.rules=[],z.setup()}),l=l||function e(){var t=+new Date,n=L(xt);return l=n?(ee.trigger(Kt),J.cost=(+new Date+J.cost-t)/2,setTimeout(e,ve(4,1e3/n-J.cost))):null}(),N(I)},unreel:function(){return this.trigger("teardown")}},re:{image:/^(.*)\.(jpg|jpeg|png|gif)\??.*$/i,ua:[/(msie|opera|firefox|chrome|safari)[ \/:]([\d.]+)/i,/(webkit)\/([\d.]+)/i,/(mozilla)\/([\d.]+)/i],array:/ *, */,lazy_agent:/\(iphone|ipod|android|fennec|blackberry/i,frame_klass:/frame-\d+/,substitution:/(@([A-Z]))/g,no_match:/^(undefined|)$/,sequence:/(^[^#|]*([#]+)[^#|]*)($|[|]([0-9]+)\.\.([0-9]+))($|[|]([0-9]+)$)/},cdn:"http://code.vostrel.net/",math:{envelope:function(e,t,n,a,i,o,r){return t+c(a,i,-e*o)/n},hatch:function(e,t,n,a,i,o,r){var c=t+-(e=(e<a?i:0)+e%i)*o/n;return c-me(c)},interpolate:function(e,t,n){return t+e*(n-t)},distance:function(e,t,n){var a=n/2,i=t-e;return i<-a?i+n:a<i?i-n:i}},preload:{fidelity:function(e,f,t){function n(e,t,n){function a(e){for(;!(1<=e&&e<=c);)e+=e<1?+c:-c;return p[n+e]||(p[n+e]=!!i.push(e))}if(!e.length)return[];for(var i=[],o=4*t,r=f.frame,c=e.length,s=!0,u=c/o,l=0;l<o;l++)a(r+pe(l*u));for(;1<u;)for(var l=0,d=i.length,u=u/2,s=!s;l<d;l++)a(i[l]+(s?1:-1)*pe(u));for(l=0;l<=c;l++)a(l);for(l=0;l<i.length;l++)i[l]=e[i[l]-1];return i}var a=f.orbital,i=a?2:f.rows||1,o=t(a?Le:Pe),r=(f.row-1)*o,c=(new Array).concat(e),p=new Array(e.length+1);return n(i<2?[]:c.slice(r,r+o),1,r).concat(n(c,i,0))},linear:function(e,t,n){return e}},substitute:function(e,a){return e.replace(J.re.substitution,function(e,t,n){return"function"==typeof J.substitutes[n]?J.substitutes[n](a):h[n]?a(h[n]):t})},substitutes:{T:function(e){return+new Date}},normal:{fraction:function(e,t){return null===e?e:t[tt].loops?e-me(e):c(0,1,e)},tier:function(e,t){return null===e?e:c(0,1,e)},row:function(e,t){return null===e?e:pe(c(1,t[tt].rows,e))},frame:function(e,t){if(null===e)return e;var n=t[tt],a=t[Pe]*(n.orbital?2:n.rows||1),i=pe(n.loops?e%a||a:c(1,a,e));return i<0?i+a:i},images:function(e,t){var n=J.re.sequence.exec(e);return n?J.sequence(n,t[tt]):e}},sequence:function(e,t){if(e.length<=1)return t.images;for(var n=[],a=t.orbital,i=e[1],o=e[2],r=e[4],r=J.re.no_match.test(r+Bt)?1:+r,c=a?2:t.rows||1,s=a?t.footage:t.stitched?1:t.frames,u=+(e[5]||c*s)-r,l=+e[7]||1,d=0;d<=u;)n.push(i.replace(o,f(r+d+Bt,o.length,"0"))),d+=l;return n},instances:N(),leader:L,resize_gauge:300,concurrent_requests:4,cost:0},ee=N(e),a=navigator.userAgent,i=J.re.ua[0].exec(a)||J.re.ua[1].exec(a)||J.re.ua[2].exec(a),o=+i[2].split(".").slice(0,2).join("."),d="MSIE"==i[1],p=!(d&&o<8),te=!(d&&o<9),ne="reel",ae=ne+"-overlay",ie=ne+"-cache",oe=ne+"-indicator",re=ne+"-preloader",ce=ne+"-monitor",se=ne+"-annotation",ue=ne+"-panning",le=ne+"-loading",de="frame-",fe=Math,pe=fe.round,me=fe.floor,ge=fe.ceil,he=fe.min,ve=fe.max,we=fe.abs,ye=parseInt,be=J.math.interpolate,_e="annotations",Ye="area",xe="auto",Xe="backup",ke="backwards",Te="bit",Ae="brake",Ce="cache",ze=Ce+"d",je="center",$e="class",Se="click",qe=Se+"ed",De=qe+"_location",Ee=qe+"_on",Fe=qe+"_tier",Ie="cwish",Ne="departure",Qe="destination",Ke="distance",Le="footage",Re="fraction",Me="frame",Oe="framelock",Pe="frames",Be="height",He="hi",Ve="hidden",Ue="image",Ze="images",Ge="lo",We="loading",Je="opening",et=Je+"_ticks",tt="options",nt="playing",at="preloaded",it="ratio",ot="reeling",rt="reeled",ct="responsive",st="revolution",ut="revolution_y",lt="row",dt="rowlock",ft="rows",pt="shy",mt="spacing",gt="speed",ht="src",vt="stage",wt="stitched",yt=wt+"_shift",bt=wt+"_travel",_t="stopped",Yt="style",xt="tempo",Xt="ticks",kt="tier",Tt="truescale",At="velocity",Ct="vertical",zt="width",jt=M(ne),$t=".pan"+jt,St="deviceorientation"+jt,qt="dragstart"+jt,Dt="mousedown"+jt,Et="mouseenter"+jt,Ft="mouseleave"+$t,It="mousemove"+$t,Nt="mouseup"+$t,Qt="mousewheel"+jt,Kt="tick"+jt,Lt="touchcancel"+$t,Rt="touchend"+$t,Mt="touchstart"+jt,Ot="touchmove"+$t,Pt="resize"+jt,Bt="",Ht=" ",Vt=",",Ut="absolute",Zt="block",m="@CDN@",Gt="div",Wt="hand",Jt="head",en="html",tn="id",nn="img",g="jquery."+ne,an="none",on="object",rn="string",cn=[zt,Be,mt,st,ut,wt,yt,bt],h={W:zt,H:Be},sn=p?"data:image/gif;base64,R0lGODlhCAAIAIAAAAAAAAAAACH5BAEAAAAALAAAAAAIAAgAAAIHhI+py+1dAAA7":m+"blank.gif",un=P(m+g+".cur")+Vt+"move",ln=P(m+g+"-drag.cur")+Vt+"move",dn=P(m+g+"-drag-down.cur")+Vt+"move",fn=(J.lazy=J.re.lazy_agent.test(a),d&&o<9?1:0),v=N.cleanData;return N.cleanData=function(e){return N(e).each(function(){N(this).triggerHandler("clean")}),v.apply(this,arguments)},N.extend(N.fn,J.fn)&&N(J.scan),J}}(jQuery,window,document)});var scrollme=function(a){var X={},e=a(document),t=a(window);return X.body_height=0,X.viewport_height=0,X.viewport_top=0,X.viewport_bottom=0,X.viewport_top_previous=-1,X.elements=[],X.elements_in_view=[],X.property_defaults={opacity:1,translatex:0,translatey:0,translatez:0,rotatex:0,rotatey:0,rotatez:0,scale:1,scalex:1,scaley:1,scalez:1},X.scrollme_selector=".scrollme",X.animateme_selector=".animateme",X.update_interval=10,X.easing_functions={linear:function(e){return e},easeout:function(e){return e*e*e},easein:function(e){return 1-(e=1-e)*e*e},easeinout:function(e){return e<.5?4*e*e*e:1-4*(e=1-e)*e*e}},X.init_events=["ready","page:load","page:change"],X.init_if=function(){return!0},X.init=function(){return!!X.init_if()&&(X.init_elements(),X.on_resize(),t.on("resize orientationchange",function(){X.on_resize()}),t.load(function(){setTimeout(function(){X.on_resize()},100)}),setInterval(X.update,X.update_interval),!0)},X.init_elements=function(){a(X.scrollme_selector).each(function(){var e={};e.element=a(this);var n=[];a(this).find(X.animateme_selector).addBack(X.animateme_selector).each(function(){var e={};e.element=a(this),e.when=e.element.data("when"),e.from=e.element.data("from"),e.to=e.element.data("to"),e.element.is("[data-crop]")?e.crop=e.element.data("crop"):e.crop=!0,e.element.is("[data-easing]")?e.easing=X.easing_functions[e.element.data("easing")]:e.easing=X.easing_functions.easeout;var t={};e.element.is("[data-opacity]")&&(t.opacity=e.element.data("opacity")),e.element.is("[data-translatex]")&&(t.translatex=e.element.data("translatex")),e.element.is("[data-translatey]")&&(t.translatey=e.element.data("translatey")),e.element.is("[data-translatez]")&&(t.translatez=e.element.data("translatez")),e.element.is("[data-rotatex]")&&(t.rotatex=e.element.data("rotatex")),e.element.is("[data-rotatey]")&&(t.rotatey=e.element.data("rotatey")),e.element.is("[data-rotatez]")&&(t.rotatez=e.element.data("rotatez")),e.element.is("[data-scale]")&&(t.scale=e.element.data("scale")),e.element.is("[data-scalex]")&&(t.scalex=e.element.data("scalex")),e.element.is("[data-scaley]")&&(t.scaley=e.element.data("scaley")),e.element.is("[data-scalez]")&&(t.scalez=e.element.data("scalez")),e.properties=t,n.push(e)}),e.effects=n,X.elements.push(e)})},X.update=function(){window.requestAnimationFrame(function(){X.update_viewport_position(),X.viewport_top_previous!=X.viewport_top&&(X.update_elements_in_view(),X.animate()),X.viewport_top_previous=X.viewport_top})},X.animate=function(){for(var e=X.elements_in_view.length,t=0;t<e;t++)for(var n=X.elements_in_view[t],a=n.effects.length,i=0;i<a;i++){var o=n.effects[i];switch(o.when){case"view":case"span":var r=n.top-X.viewport_height,c=n.bottom;break;case"exit":r=n.bottom-X.viewport_height,c=n.bottom;break;default:r=n.top-X.viewport_height,c=n.top}o.crop&&(r<0&&(r=0),c>X.body_height-X.viewport_height&&(c=X.body_height-X.viewport_height));var s=(X.viewport_top-r)/(c-r),u=o.from,l=o.to,d=(s-u)/(l-u),f=o.easing(d),p=X.animate_value(s,f,u,l,o,"opacity"),m=X.animate_value(s,f,u,l,o,"translatey"),g=X.animate_value(s,f,u,l,o,"translatex"),h=X.animate_value(s,f,u,l,o,"translatez"),v=X.animate_value(s,f,u,l,o,"rotatex"),w=X.animate_value(s,f,u,l,o,"rotatey"),y=X.animate_value(s,f,u,l,o,"rotatez"),b=X.animate_value(s,f,u,l,o,"scale"),_=X.animate_value(s,f,u,l,o,"scalex"),Y=X.animate_value(s,f,u,l,o,"scaley"),x=X.animate_value(s,f,u,l,o,"scalez");"scale"in o.properties&&(x=Y=_=b),o.element.css({opacity:p,transform:"translate3d( "+g+"px , "+m+"px , "+h+"px ) rotateX( "+v+"deg ) rotateY( "+w+"deg ) rotateZ( "+y+"deg ) scale3d( "+_+" , "+Y+" , "+x+" )"})}},X.animate_value=function(e,t,n,a,i,o){var r=X.property_defaults[o];if(!(o in i.properties))return r;var c=i.properties[o],s=n<a;if(e<n&&s)return r;if(a<e&&s)return c;if(n<e&&!s)return r;if(e<a&&!s)return c;var u=r+t*(c-r);switch(o){case"opacity":u=u.toFixed(2);break;case"translatex":case"translatey":case"translatez":u=u.toFixed(0);break;case"rotatex":case"rotatey":case"rotatez":u=u.toFixed(1);break;case"scale":u=u.toFixed(3)}return u},X.update_viewport_position=function(){X.viewport_top=t.scrollTop(),X.viewport_bottom=X.viewport_top+X.viewport_height},X.update_elements_in_view=function(){X.elements_in_view=[];for(var e=X.elements.length,t=0;t<e;t++)X.elements[t].top<X.viewport_bottom&&X.elements[t].bottom>X.viewport_top&&X.elements_in_view.push(X.elements[t])},X.on_resize=function(){X.update_viewport(),X.update_element_heights(),X.update_viewport_position(),X.update_elements_in_view(),X.animate()},X.update_viewport=function(){X.body_height=e.height(),X.viewport_height=t.height()},X.update_element_heights=function(){for(var e=X.elements.length,t=0;t<e;t++){var n=X.elements[t].element.outerHeight(),a=X.elements[t].element.offset();X.elements[t].height=n,X.elements[t].top=a.top,X.elements[t].bottom=a.top+n}},e.on(X.init_events.join(" "),function(){X.init()}),X}(jQuery);$(document).ready(function(){function e(e){var t;e.preventDefault(),$(window).scrollTop()>=a?(i.addClass("navbar-fixed-top"),$("body").css("padding-top",i.outerHeight(!0))):(i.removeClass("navbar-fixed-top"),$("body").css("padding-top",0)),
// (d=window.pageYOffset)<700}function n(){u.currentTime=s-s/(r-t)*(d-t)}var a=$(".navbar-first").outerHeight(!0),i=$(".navbar-second"),o=window.pageYOffset,r=260,t=50,c=.15,s=2.0666,u=document.getElementById("hero-video"),l=!0,d=0;-1!=navigator.userAgent.indexOf("Chrome")?$(window).on("scroll",$.throttle(10,e)):$(window).on("scroll",e);var f=Promise.resolve();$(".nav a").on("click",function(e){var t;""!==this.hash&&(e.preventDefault(),t=this.hash,$("html, body").animate({scrollTop:$(t).offset().top},1e3,function(){window.location.hash=t}))}),$("#feature-reveal").twentytwenty();var p,m,g,h,v,w=$("#sets-carousel");w.owlCarousel({center:!0,dots:!1,items:1,loop:!0,margin:10,responsive:{767:{items:2}}}),$(".carousel-back").click(function(){w.trigger("prev.owl.carousel")}),$(".carousel-forward").click(function(){w.trigger("next.owl.carousel")}),$("#filling").fitVids(),window.screen.width<768&&((p=$(".top.animateme")[0]).dataset.translatey="20",p.dataset.from="0.4",p.dataset.to="0.2",(m=$(".bot.animateme")[0]).dataset.translatey="-15",m.dataset.from="0.4",m.dataset.to="0.2",(g=$(".stat-block.sb1")[0]).dataset.translatey="-50",g.dataset.opacity="0",g.dataset.from="0.4",g.dataset.to="0.2",(h=$(".stat-block.sb2")[0]).dataset.translatey="-50",h.dataset.opacity="0",h.dataset.from="0.43",h.dataset.to="0.23",(v=$(".stat-block.sb3")[0]).dataset.translatey="-50",v.dataset.opacity="0",v.dataset.from="0.46",v.dataset.to="0.26");var y=$(".navbar-collapse");y.on("click","a:not([data-toggle])",null,function(){y.collapse("hide")}),$(".swatch-popup").magnificPopup({type:"image",closeBtnInside:!1,gallery:{enabled:!0}}),$(".iframe-popup").magnificPopup({type:"iframe",closeBtnInside:!1}),$.ajax({type:"GET",dataType:"json",url:"https://graph.facebook.com/ambientlounge/?fields=fan_count&access_token=133219273933374|VRedlipjgEwKzF4a3hKMfzTqpFg",success:function(e){var t=e.fan_count;$(".social-tip").html(t.toLocaleString())}})}),$(window).load(function(){$("#feature-reveal").twentytwenty()});
! function(g) {
    g.fn.twentytwenty = function(m) {
        m = g.extend({
            default_offset_pct: .5,
            orientation: "horizontal"
        }, m);
        return this.each(function() {
            var t = m.default_offset_pct,
                r = g(this),
                c = m.orientation,
                e = "vertical" === c ? "down" : "left",
                n = "vertical" === c ? "up" : "right";
            r.wrap("<div class='twentytwenty-wrapper twentytwenty-" + c + "'></div>"), r.append("<div class='twentytwenty-overlay'></div>");
            var s = r.find("img:first"),
                a = r.find("img:last");
            r.append("<div class='twentytwenty-handle'></div>");
            var u = r.find(".twentytwenty-handle");
            u.append("<span class='twentytwenty-" + e + "-arrow'></span>"), u.append("<span class='twentytwenty-" + n + "-arrow'></span>"), r.addClass("twentytwenty-container"), s.addClass("twentytwenty-before"), a.addClass("twentytwenty-after");
            var i = r.find(".twentytwenty-overlay");
            i.append("<div class='twentytwenty-before-label'></div>"), i.append("<div class='twentytwenty-after-label'></div>");

            function o(e) {
                var t, n, a, i, o = (t = e, n = s.width(), a = s.height(), {
                    w: n + "px",
                    h: a + "px",
                    cw: t * n + "px",
                    ch: t * a + "px"
                });
                u.css("vertical" === c ? "top" : "left", "vertical" === c ? o.ch : o.cw), i = o, "vertical" === c ? s.css("clip", "rect(0," + i.w + "," + i.ch + ",0)") : s.css("clip", "rect(0," + i.cw + "," + i.h + ",0)"), r.css("height", i.h)
            }
            g(window).on("resize.twentytwenty", function(e) {
                o(t)
            });
            var l = 0,
                d = 0,
                f = 0,
                p = 0;
            u.on("movestart", function(e) {
                ((e.distX > e.distY && e.distX < -e.distY || e.distX < e.distY && e.distX > -e.distY) && "vertical" !== c || (e.distX < e.distY && e.distX < -e.distY || e.distX > e.distY && e.distX > -e.distY) && "vertical" === c) && e.preventDefault(), r.addClass("active"), l = r.offset().left, d = r.offset().top, f = s.width(), p = s.height()
            }), u.on("moveend", function(e) {
                r.removeClass("active")
            }), u.on("move", function(e) {
                r.hasClass("active") && ((t = "vertical" === c ? (e.pageY - d) / p : (e.pageX - l) / f) < 0 && (t = 0), 1 < t && (t = 1), o(t))
            }), r.find("img").on("mousedown", function(e) {
                e.preventDefault()
            }), g(window).trigger("resize.twentytwenty")
        })
    }
}(jQuery),
function(o) {
    "use strict";
    o.fn.fitVids = function(e) {
        var t, n, i = {
            customSelector: null,
            ignore: null
        };
        return document.getElementById("fit-vids-style") || (t = document.head || document.getElementsByTagName("head")[0], (n = document.createElement("div")).innerHTML = '<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>', t.appendChild(n.childNodes[1])), e && o.extend(i, e), this.each(function() {
            var e = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
            i.customSelector && e.push(i.customSelector);
            var a = ".fitvidsignore";
            i.ignore && (a = a + ", " + i.ignore);
            var t = o(this).find(e.join(","));
            (t = (t = t.not("object object")).not(a)).each(function() {
                var e, t, n = o(this);
                0 < n.parents(a).length || "embed" === this.tagName.toLowerCase() && n.parent("object").length || n.parent(".fluid-width-video-wrapper").length || (n.css("height") || n.css("width") || !isNaN(n.attr("height")) && !isNaN(n.attr("width")) || (n.attr("height", 9), n.attr("width", 16)), e = ("object" === this.tagName.toLowerCase() || n.attr("height") && !isNaN(parseInt(n.attr("height"), 10)) ? parseInt(n.attr("height"), 10) : n.height()) / (isNaN(parseInt(n.attr("width"), 10)) ? n.width() : parseInt(n.attr("width"), 10)), n.attr("name") || (t = "fitvid" + o.fn.fitVids._count, n.attr("name", t), o.fn.fitVids._count++), n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * e + "%"), n.removeAttr("height").removeAttr("width"))
            })
        })
    }, o.fn.fitVids._count = 0
}(window.jQuery || window.Zepto),
function(e) {
    "function" == typeof define && define.amd ? define([], e) : "undefined" != typeof module && null !== module && module.exports ? module.exports = e : e()
}(function() {
    function s(e) {
        return e[$] || (e[$] = {})
    }

    function a(e, t, n, a) {
        function i(e) {
            n(e, a)
        }
        t = t.split(z);
        for (var o, r = s(e), c = t.length; c--;)(r[o = t[c]] || (r[o] = [])).push([n, i]), e.addEventListener(o, i)
    }

    function r(e, t, n) {
        t = t.split(z);
        var a, i, o, r = s(e),
            c = t.length;
        if (r)
            for (; c--;)
                if (i = r[a = t[c]])
                    for (o = i.length; o--;) i[o][0] === n && (e.removeEventListener(a, i[o][1]), i.splice(o, 1))
    }

    function g(e, t, n) {
        var a = new CustomEvent(t, j);
        n && x(a, n), e.dispatchEvent(a)
    }

    function t(e) {
        function t(e) {
            a ? (n(), k(t), a = !(i = !0)) : i = !1
        }
        var n = e,
            a = !1,
            i = !1;
        this.kick = function(e) {
            a = !0, i || t()
        }, this.end = function(e) {
            var t = n;
            e && (i ? (n = a ? function() {
                t(), e()
            } : e, a = !0) : e())
        }
    }

    function h() {}

    function c(e) {
        e.preventDefault()
    }

    function u(e, t) {
        var n, a;
        if (e.identifiedTouch) return e.identifiedTouch(t);
        for (n = -1, a = e.length; ++n < a;)
            if (e[n].identifier === t) return e[n]
    }

    function l(e, t) {
        var n = u(e.changedTouches, t.identifier);
        if (n && (n.pageX !== t.pageX || n.pageY !== t.pageY)) return n
    }

    function n(e, t) {
        f(e, t, e, o)
    }

    function i(e, t) {
        o()
    }

    function o() {
        r(document, A.move, n), r(document, A.cancel, i)
    }

    function d(e) {
        r(document, C.move, e.touchmove), r(document, C.cancel, e.touchend)
    }

    function f(e, t, n, a) {
        var i, o, r, c, s, u, l, d, f, p = n.pageX - t.pageX,
            m = n.pageY - t.pageY;
        p * p + m * m < X * X || (o = t, r = n, c = p, s = m, u = a, l = (i = e).targetTouches, d = i.timeStamp - o.timeStamp, f = {
            altKey: i.altKey,
            ctrlKey: i.ctrlKey,
            shiftKey: i.shiftKey,
            startX: o.pageX,
            startY: o.pageY,
            distX: c,
            distY: s,
            deltaX: c,
            deltaY: s,
            pageX: r.pageX,
            pageY: r.pageY,
            velocityX: c / d,
            velocityY: s / d,
            identifier: o.identifier,
            targetTouches: l,
            finger: l ? l.length : 1,
            enableMove: function() {
                this.moveEnabled = !0, this.enableMove = h, i.preventDefault()
            }
        }, g(o.target, "movestart", f), u(o))
    }

    function p(e, t) {
        var n = t.timer;
        t.touch = e, t.timeStamp = e.timeStamp, n.kick()
    }

    function m(e, t) {
        var n = t.target,
            a = t.event,
            i = t.timer;
        r(document, A.move, p), r(document, A.end, m), w(n, a, i, function() {
            setTimeout(function() {
                r(n, "click", c)
            }, 0)
        })
    }

    function v(e, t) {
        var n, a = t.target,
            i = t.event,
            o = t.timer;
        u(e.changedTouches, i.identifier) && (n = t, r(document, C.move, n.activeTouchmove), r(document, C.end, n.activeTouchend), w(a, i, o))
    }

    function w(e, t, n, a) {
        n.end(function() {
            return g(e, "moveend", t), a && a()
        })
    }

    function e(e) {
        e.enableMove()
    }

    function y(e) {
        e.enableMove()
    }

    function b(e) {
        e.enableMove()
    }

    function _(e) {
        var a = e.handler;
        e.handler = function(e) {
            for (var t, n = Y.length; n--;) e[t = Y[n]] = e.originalEvent[t];
            a.apply(this, arguments)
        }
    }
    var Y, x = Object.assign || window.jQuery && jQuery.extend,
        X = 8,
        k = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e, t) {
            return window.setTimeout(function() {
                e()
            }, 25)
        },
        T = {
            textarea: !0,
            input: !0,
            select: !0,
            button: !0
        },
        A = {
            move: "mousemove",
            cancel: "mouseup dragstart",
            end: "mouseup"
        },
        C = {
            move: "touchmove",
            cancel: "touchend",
            end: "touchend"
        },
        z = /\s+/,
        j = {
            bubbles: !0,
            cancelable: !0
        },
        $ = Symbol("events");
    a(document, "mousedown", function(e) {
        var t;
        1 !== (t = e).which || t.ctrlKey || t.altKey || (T[e.target.tagName.toLowerCase()] || (a(document, A.move, n, e), a(document, A.cancel, i, e)))
    }), a(document, "touchstart", function(e) {
        var t, n;
        T[e.target.tagName.toLowerCase()] || (n = {
            target: (t = e.changedTouches[0]).target,
            pageX: t.pageX,
            pageY: t.pageY,
            identifier: t.identifier,
            touchmove: function(e, t) {
                var n, a, i;
                (i = l(n = e, a = t)) && f(n, a, i, d)
            },
            touchend: function(e, t) {
                var n;
                n = t, u(e.changedTouches, n.identifier) && d(n)
            }
        }, a(document, C.move, n.touchmove, n), a(document, C.cancel, n.touchend, n))
    }), a(document, "movestart", function(e) {
        var o, r;
        !e.defaultPrevented && e.moveEnabled && (o = {
            startX: e.startX,
            startY: e.startY,
            pageX: e.pageX,
            pageY: e.pageY,
            distX: e.distX,
            distY: e.distY,
            deltaX: e.deltaX,
            deltaY: e.deltaY,
            velocityX: e.velocityX,
            velocityY: e.velocityY,
            identifier: e.identifier,
            targetTouches: e.targetTouches,
            finger: e.finger
        }, r = {
            target: e.target,
            event: o,
            timer: new t(function(e) {
                var t, n, a, i;
                t = o, n = r.touch, a = r.timeStamp, i = a - t.timeStamp, t.distX = n.pageX - t.startX, t.distY = n.pageY - t.startY, t.deltaX = n.pageX - t.pageX, t.deltaY = n.pageY - t.pageY, t.velocityX = .3 * t.velocityX + .7 * t.deltaX / i, t.velocityY = .3 * t.velocityY + .7 * t.deltaY / i, t.pageX = n.pageX, t.pageY = n.pageY, g(r.target, "move", o)
            }),
            touch: void 0,
            timeStamp: e.timeStamp
        }, void 0 === e.identifier ? (a(e.target, "click", c), a(document, A.move, p, r), a(document, A.end, m, r)) : (r.activeTouchmove = function(e, t) {
            var n, a, i, o, r;
            n = e, i = (a = t).event, o = a.timer, (r = l(n, i)) && (n.preventDefault(), i.targetTouches = n.targetTouches, a.touch = r, a.timeStamp = n.timeStamp, o.kick())
        }, r.activeTouchend = function(e, t) {
            v(e, t)
        }, a(document, C.move, r.activeTouchmove, r), a(document, C.end, r.activeTouchend, r)))
    }), window.jQuery && (Y = "startX startY pageX pageY distX distY deltaX deltaY velocityX velocityY".split(" "), jQuery.event.special.movestart = {
        setup: function() {
            return a(this, "movestart", e), !1
        },
        teardown: function() {
            return r(this, "movestart", e), !1
        },
        add: _
    }, jQuery.event.special.move = {
        setup: function() {
            return a(this, "movestart", y), !1
        },
        teardown: function() {
            return r(this, "movestart", y), !1
        },
        add: _
    }, jQuery.event.special.moveend = {
        setup: function() {
            return a(this, "movestart", b), !1
        },
        teardown: function() {
            return r(this, "movestart", b), !1
        },
        add: _
    })
}),
function(e) {
    "function" == typeof define && define.amd ? define([], e) : "undefined" != typeof module && null !== module && module.exports ? module.exports = e : e()
}(function() {
    function s(e) {
        return e[$] || (e[$] = {})
    }

    function a(e, t, n, a) {
        function i(e) {
            n(e, a)
        }
        t = t.split(z);
        for (var o, r = s(e), c = t.length; c--;)(r[o = t[c]] || (r[o] = [])).push([n, i]), e.addEventListener(o, i)
    }

    function r(e, t, n) {
        t = t.split(z);
        var a, i, o, r = s(e),
            c = t.length;
        if (r)
            for (; c--;)
                if (i = r[a = t[c]])
                    for (o = i.length; o--;) i[o][0] === n && (e.removeEventListener(a, i[o][1]), i.splice(o, 1))
    }

    function g(e, t, n) {
        var a = new CustomEvent(t, j);
        n && x(a, n), e.dispatchEvent(a)
    }

    function t(e) {
        function t(e) {
            a ? (n(), k(t), a = !(i = !0)) : i = !1
        }
        var n = e,
            a = !1,
            i = !1;
        this.kick = function(e) {
            a = !0, i || t()
        }, this.end = function(e) {
            var t = n;
            e && (i ? (n = a ? function() {
                t(), e()
            } : e, a = !0) : e())
        }
    }

    function h() {}

    function c(e) {
        e.preventDefault()
    }

    function u(e, t) {
        var n, a;
        if (e.identifiedTouch) return e.identifiedTouch(t);
        for (n = -1, a = e.length; ++n < a;)
            if (e[n].identifier === t) return e[n]
    }

    function l(e, t) {
        var n = u(e.changedTouches, t.identifier);
        if (n && (n.pageX !== t.pageX || n.pageY !== t.pageY)) return n
    }

    function i(e, t) {
        f(e, t, e, n)
    }

    function o(e, t) {
        n()
    }

    function n() {
        r(document, A.move, i), r(document, A.cancel, o)
    }

    function d(e) {
        r(document, C.move, e.touchmove), r(document, C.cancel, e.touchend)
    }

    function f(e, t, n, a) {
        var i, o, r, c, s, u, l, d, f, p = n.pageX - t.pageX,
            m = n.pageY - t.pageY;
        p * p + m * m < X * X || (o = t, r = n, c = p, s = m, u = a, l = (i = e).targetTouches, d = i.timeStamp - o.timeStamp, f = {
            altKey: i.altKey,
            ctrlKey: i.ctrlKey,
            shiftKey: i.shiftKey,
            startX: o.pageX,
            startY: o.pageY,
            distX: c,
            distY: s,
            deltaX: c,
            deltaY: s,
            pageX: r.pageX,
            pageY: r.pageY,
            velocityX: c / d,
            velocityY: s / d,
            identifier: o.identifier,
            targetTouches: l,
            finger: l ? l.length : 1,
            enableMove: function() {
                this.moveEnabled = !0, this.enableMove = h, i.preventDefault()
            }
        }, g(o.target, "movestart", f), u(o))
    }

    function p(e, t) {
        var n = t.timer;
        t.touch = e, t.timeStamp = e.timeStamp, n.kick()
    }

    function m(e, t) {
        var n = t.target,
            a = t.event,
            i = t.timer;
        r(document, A.move, p), r(document, A.end, m), w(n, a, i, function() {
            setTimeout(function() {
                r(n, "click", c)
            }, 0)
        })
    }

    function v(e, t) {
        var n, a = t.target,
            i = t.event,
            o = t.timer;
        u(e.changedTouches, i.identifier) && (n = t, r(document, C.move, n.activeTouchmove), r(document, C.end, n.activeTouchend), w(a, i, o))
    }

    function w(e, t, n, a) {
        n.end(function() {
            return g(e, "moveend", t), a && a()
        })
    }

    function e(e) {
        e.enableMove()
    }

    function y(e) {
        e.enableMove()
    }

    function b(e) {
        e.enableMove()
    }

    function _(e) {
        var a = e.handler;
        e.handler = function(e) {
            for (var t, n = Y.length; n--;) e[t = Y[n]] = e.originalEvent[t];
            a.apply(this, arguments)
        }
    }
    var Y, x = Object.assign || window.jQuery && jQuery.extend,
        X = 8,
        k = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e, t) {
            return window.setTimeout(function() {
                e()
            }, 25)
        },
        T = {
            textarea: !0,
            input: !0,
            select: !0,
            button: !0
        },
        A = {
            move: "mousemove",
            cancel: "mouseup dragstart",
            end: "mouseup"
        },
        C = {
            move: "touchmove",
            cancel: "touchend",
            end: "touchend"
        },
        z = /\s+/,
        j = {
            bubbles: !0,
            cancelable: !0
        },
        $ = Symbol("events");
    a(document, "mousedown", function(e) {
        var t, n;
        1 !== (n = e).which || n.ctrlKey || n.altKey || ((t = e).target && T[t.target.tagName.toLowerCase()] || (a(document, A.move, i, e), a(document, A.cancel, o, e)))
    }), a(document, "touchstart", function(e) {
        var t, n;
        T[e.target.tagName.toLowerCase()] || (n = {
            target: (t = e.changedTouches[0]).target,
            pageX: t.pageX,
            pageY: t.pageY,
            identifier: t.identifier,
            touchmove: function(e, t) {
                var n, a, i;
                (i = l(n = e, a = t)) && f(n, a, i, d)
            },
            touchend: function(e, t) {
                var n;
                n = t, u(e.changedTouches, n.identifier) && d(n)
            }
        }, a(document, C.move, n.touchmove, n), a(document, C.cancel, n.touchend, n))
    }), a(document, "movestart", function(e) {
        var o, r;
        !e.defaultPrevented && e.moveEnabled && (o = {
            startX: e.startX,
            startY: e.startY,
            pageX: e.pageX,
            pageY: e.pageY,
            distX: e.distX,
            distY: e.distY,
            deltaX: e.deltaX,
            deltaY: e.deltaY,
            velocityX: e.velocityX,
            velocityY: e.velocityY,
            identifier: e.identifier,
            targetTouches: e.targetTouches,
            finger: e.finger
        }, r = {
            target: e.target,
            event: o,
            timer: new t(function(e) {
                var t, n, a, i;
                t = o, n = r.touch, a = r.timeStamp, i = a - t.timeStamp, t.distX = n.pageX - t.startX, t.distY = n.pageY - t.startY, t.deltaX = n.pageX - t.pageX, t.deltaY = n.pageY - t.pageY, t.velocityX = .3 * t.velocityX + .7 * t.deltaX / i, t.velocityY = .3 * t.velocityY + .7 * t.deltaY / i, t.pageX = n.pageX, t.pageY = n.pageY, g(r.target, "move", o)
            }),
            touch: void 0,
            timeStamp: e.timeStamp
        }, void 0 === e.identifier ? (a(e.target, "click", c), a(document, A.move, p, r), a(document, A.end, m, r)) : (r.activeTouchmove = function(e, t) {
            var n, a, i, o, r;
            n = e, i = (a = t).event, o = a.timer, (r = l(n, i)) && (n.preventDefault(), i.targetTouches = n.targetTouches, a.touch = r, a.timeStamp = n.timeStamp, o.kick())
        }, r.activeTouchend = function(e, t) {
            v(e, t)
        }, a(document, C.move, r.activeTouchmove, r), a(document, C.end, r.activeTouchend, r)))
    }), window.jQuery && (Y = "startX startY pageX pageY distX distY deltaX deltaY velocityX velocityY".split(" "), jQuery.event.special.movestart = {
        setup: function() {
            return a(this, "movestart", e), !1
        },
        teardown: function() {
            return r(this, "movestart", e), !1
        },
        add: _
    }, jQuery.event.special.move = {
        setup: function() {
            return a(this, "movestart", y), !1
        },
        teardown: function() {
            return r(this, "movestart", y), !1
        },
        add: _
    }, jQuery.event.special.moveend = {
        setup: function() {
            return a(this, "movestart", b), !1
        },
        teardown: function() {
            return r(this, "movestart", b), !1
        },
        add: _
    })
}),
function(e) {
    var t = "function" == typeof define && define.amd && (define(["jquery"], e) || !0),
        n = !t && "object" == typeof module && "object" == typeof module.exports && (module.exports = e);
    t || n || e()
}(function() {
    return jQuery.reel || function(N, Q, e, K) {
        function L(e) {
            return J.instances.first().data(e)
        }

        function R(e) {
            return "<" + e + "/>"
        }

        function M(e) {
            return "." + (e || "")
        }

        function O(e) {
            return e.replace(m, J.cdn)
        }

        function P(e) {
            return "url('" + W(e) + "')"
        }

        function B(e, t) {
            return typeof t == on ? t[e] : t
        }

        function c(e, t, n) {
            return ve(e, he(t, n))
        }

        function H(e, t) {
            return we(e) * (t ? -1 : 1)
        }

        function V(e) {
            return e.touch || e.originalEvent.touches && e.originalEvent.touches[0] || e
        }

        function U(e) {
            return e.originalEvent
        }

        function Z(e) {
            return e === K ? 0 : typeof e == rn ? e : e + "px"
        }

        function G(e) {
            return "#" + e
        }

        function f(e, t, n) {
            for (; e.length < t;) e = n + e;
            return e
        }

        function t(e) {
            return f(e, 2, "0")
        }

        function W(e) {
            return encodeURI(decodeURI(e))
        }

        function r(e) {
            return J.re.array.exec(e) ? e.split(J.re.array) : e
        }

        function s(n) {
            return typeof n == rn ? n : N.each(n, function(e, t) {
                n[e] = t ? +t : K
            })
        }

        function u(e) {
            try {
                console.error("[ Reel ] " + e)
            } catch (e) {}
        }
        if (N) {
            var n = N && N().jquery.split(/\./);
            if (!n || +(t(n[0]) + t(n[1]) + t(n[2] || "")) < 10602) return u("Too old jQuery library. Please upgrade your jQuery to version 1.6.2 or higher");
            var l, J = N.reel = {
                    version: "1.3.0",
                    def: {
                        frame: 1,
                        frames: 36,
                        loops: !0,
                        clickfree: !1,
                        draggable: !0,
                        scrollable: !0,
                        steppable: !0,
                        throwable: !0,
                        wheelable: !0,
                        orientable: !1,
                        cw: !1,
                        revolution: K,
                        stitched: 0,
                        directional: !1,
                        row: 1,
                        rows: 0,
                        rowlock: !1,
                        framelock: !1,
                        orbital: 0,
                        vertical: !1,
                        inversed: !1,
                        footage: 6,
                        spacing: 0,
                        horizontal: !0,
                        suffix: "-reel",
                        image: K,
                        images: "",
                        path: "",
                        preload: "fidelity",
                        shy: !1,
                        speed: 0,
                        delay: 0,
                        timeout: 2,
                        duration: K,
                        rebound: .5,
                        entry: K,
                        opening: 0,
                        brake: .23,
                        velocity: 0,
                        tempo: 36,
                        laziness: 6,
                        cursor: K,
                        hint: "",
                        indicator: 0,
                        klass: "",
                        preloader: 2,
                        area: K,
                        attr: {},
                        annotations: K,
                        responsive: !1,
                        graph: K,
                        monitor: K
                    },
                    scan: function() {
                        return N(M(ne) + ":not(" + M(ae) + " > " + M(ne) + ")").each(function(e, t) {
                            var n = N(t),
                                a = n.data(),
                                o = (a.images = r(a.images), {});
                            N(M(se) + "[data-for=" + n.attr(tn) + "]").each(function(e, t) {
                                var n = N(t),
                                    a = n.data(),
                                    i = (a.x = s(r(a.x)), a.y = s(r(a.y)), n.attr(tn));
                                a.node = n.removeData(), o[i] = a
                            }), a.annotations = o, n.removeData().reel(a)
                        })
                    },
                    fn: {
                        reel: function() {
                            var e = arguments,
                                t = N(this),
                                n = t.data(),
                                a = e[0] || {},
                                i = e[1];
                            if ("object" != typeof a) return ":" == a.slice(0, 1) ? t.trigger(a.slice(1), i) : 1 == e.length ? n[a] : (i !== K && (J.normal[a] && (i = J.normal[a](i, n)), n[a] === K ? n[a] = i : n[a] !== i && t.trigger(a + "Change", [K, n[a] = i])), t);
                            var F = N.extend({}, J.def, a),
                                o = t.filter(nn).unreel().filter(function() {
                                    var e = N(this),
                                        t = F.attr,
                                        n = t.src || e.attr(ht),
                                        a = t.width || e.attr(Be) || e.width(),
                                        i = t.height || e.attr(zt) || e.height();
                                    return n ? !(!a || !i) || u("Dimension(s) of the target image unknown") : u("`src` attribute missing on target image")
                                }),
                                I = [];
                            return o.each(function() {
                                function T(e, t) {
                                    return A.reel(e, t) && C(e)
                                }
                                var s, a, i, A = N(this),
                                    C = function(e) {
                                        return A.data(e)
                                    },
                                    z = {
                                        setup: function(e) {
                                            var t, n, a, i, o, r, c, s, u, l, d, f, p, m, g, h, v, w, y, b, _, Y, x, X, k;
                                            A.hasClass(ne) && A.parent().hasClass(ae) || (T(tt, F), t = {
                                                src: A.attr(ht),
                                                width: A.attr(zt) || null,
                                                height: A.attr(Be) || null,
                                                style: A.attr(Yt) || null,
                                                class: A.attr($e) || null
                                            }, n = A.attr(F.attr).attr(ht), a = T(tn, A.attr(tn) || A.attr(tn, ne + "-" + +new Date).attr(tn)), i = N.extend({}, A.data()), o = T(Ze, F.images || []), r = T(wt, F.stitched), c = !o.length || r, s = T(ct, F.responsive && (!!te || !c)), u = T(Tt, {}), l = F.loops, d = F.orbital, f = F.revolution, y = F.rows, p = T(Le, he(F.footage, F.frames)), T(mt, F.spacing), m = T(zt, +A.attr(zt) || A.width()), g = T(Be, +A.attr(Be) || A.height()), h = T(pt, F.shy), v = T(Pe, d && p || y <= 1 && o.length || F.frames), w = 1 < y || d, T(st, B("x", f) || r / 2 || 2 * m), T(ut, w ? B("y", f) || (3 < y ? g : g / (5 - y)) : 0), y = r ? 1 : ge(v / p), T(bt, r - (l ? 0 : m)), T(yt, 0), b = G(a + F.suffix), Y = (_ = A.attr($e)) ? _ + Ht : Bt, X = N(R(Gt), {
                                                id: b.substr(1),
                                                class: Y + Ht + ae + Ht + de + "0"
                                            }), x = A.wrap(X.addClass(F.klass)).addClass(ne), I.push((k = x, J.instances.push(k[0]) && k)[0]), X = x.parent().bind(z.instance), T(Ue, o.length ? Bt : F.image || n.replace(J.re.image, "$1" + F.suffix + ".$2")), T(Ce, N(R(Gt), {
                                                class: ie
                                            }).appendTo("body")), T(Ye, N()), T(ze, []), T(Me, null), T(Re, null), T(lt, F.row), T(kt, 0), T(ft, y), T(dt, F.rowlock), T(Oe, F.framelock), T(Ne, T(Qe, T(Ke, 0))), T(Te, 1 / v), T(vt, b), T(ke, T(gt, F.speed) < 0), T(We, !1), T(At, 0), T(Ct, F.vertical), T(at, 0), T(Ie, H(1, !F.cw && !r)), T(De, {}), T(qe, !1), T(Ee, T(Fe, 0)), T(Ge, T(He, 0)), T(ot, !1), T(rt, !1), T(Je, !1), T(Ae, F.brake), T(je, !!d), T(xt, F.tempo / (J.lazy ? F.laziness : 1)), T(et, -1), T(Xt, -1), T(_e, F.annotations || X.unbind(M(_e)) && {}), T(it, 1), T(Xe, {
                                                attr: t,
                                                data: i
                                            }), F.steppable || X.unbind("up.steppable"), F.indicator || X.unbind(".indicator"), j(Bt, {
                                                overflow: Ve,
                                                position: "relative"
                                            }), s || j(Bt, {
                                                width: m,
                                                height: g
                                            }), s && N.each(cn, function(e, t) {
                                                u[t] = C(t)
                                            }), j(Vt + Ht + M(ne), {
                                                display: Zt
                                            }), j(M(ie), {
                                                position: "fixed",
                                                left: Z(-100),
                                                top: Z(-100)
                                            }, !0), j(M(ie) + Ht + nn, {
                                                position: Ut,
                                                width: 10,
                                                height: 10
                                            }, !0), ee.bind(z.pool), A.trigger(h ? "prepare" : "setup"))
                                        },
                                        instance: {
                                            teardown: function(e) {
                                                var t, n = A.data(Xe);
                                                A.parent().unbind(z.instance), C(pt) ? A.parent().unbind(Se, l) : C(Yt).remove() && C(Ye).unbind(jt), C(Ce).empty(), clearTimeout(a), clearTimeout(i), N(Q).unbind(Pt, k), N(Q).unbind(jt), ee.unbind(z.pool), E.unbind($t), A.siblings().unbind(jt).remove(), Y(), A.removeAttr("onloaded"), t = A.unbind(jt).removeData().unwrap().attr(n.attr).data(n.data), J.instances = J.instances.not(G(t.attr(tn))), A.attr(Yt) == Bt && A.removeAttr(Yt)
                                            },
                                            setup: function(e) {
                                                function t(e) {
                                                    return A.trigger("down", [V(e).clientX, V(e).clientY, e]) && e.give
                                                }
                                                var n = A.parent().append(m()),
                                                    a = T(Ye, N(F.area || n)),
                                                    i = 1 < F.rows,
                                                    o = F.cursor,
                                                    r = o == Wt ? ln : o || un,
                                                    c = o == Wt ? dn + Ht + "!important" : K;
                                                j(Ht + M(ne), {
                                                    MozUserSelect: an,
                                                    WebkitUserSelect: an,
                                                    MozTransform: "translateZ(0)"
                                                }), A.unbind(Se, l), a.bind(Mt, t).bind(F.clickfree ? Et : Dt, t).bind(F.wheelable ? Qt : null, function(e, t) {
                                                    return !t || A.trigger("wheel", [t, e]) && e.give
                                                }).bind(qt, function() {
                                                    return !1
                                                }), j(Bt, {
                                                    cursor: O(r)
                                                }), j(M(le), {
                                                    cursor: "wait"
                                                }), j(M(ue) + Vt + M(ue) + " *", {
                                                    cursor: O(c || r)
                                                }, !0), C(ct) && (j(Ht + M(ne), {
                                                    width: "100%",
                                                    height: xe
                                                }), N(Q).bind(Pt, k)), F.hint && a.attr("title", F.hint), F.indicator && n.append(g("x")), i && F.indicator && n.append(g("y")), F.monitor && n.append(p = N(R(Gt), {
                                                    class: ce
                                                })) && j(Ht + M(ce), {
                                                    position: Ut,
                                                    left: 0,
                                                    top: 0
                                                })
                                            },
                                            preload: function(e) {
                                                function t() {
                                                    var e = s.children(":not([src]):first");
                                                    return e.attr(ht, e.data(ht))
                                                }
                                                var n = A.parent(),
                                                    a = C(Ze),
                                                    i = !a.length,
                                                    o = J.preload[F.preload] || J.preload[J.def.preload],
                                                    r = i ? [C(Ue)] : o(a.slice(0), F, C),
                                                    c = (r.length, T(at, i ? .5 : 0), 0),
                                                    s = C(Ce).empty(),
                                                    u = [];
                                                for (n.addClass(le), T(Yt, C(Yt) || N("<" + Yt + ' type="text/css">' + j.rules.join("\n") + "</" + Yt + ">").prependTo(Jt)), T(We, !0), A.trigger("stop"), F.responsive && $(), A.trigger("resize", !0); r.length;) {
                                                    var l = J.substitute(F.path + r.shift(), C);
                                                    N(R(nn)).data(ht, l).appendTo(s).bind("load error abort", function(e) {
                                                        return "load" != e.type && A.trigger(e.type), !!n.parents(en).length && A.trigger("preloaded") && t() && !1
                                                    }), u.push(l)
                                                }
                                                setTimeout(function() {
                                                    for (; ++c < J.concurrent_requests;) t()
                                                }, 0), T(ze, u), T(pt, !1)
                                            },
                                            preloaded: function(e) {
                                                var t = C(Ze).length || 1,
                                                    n = T(at, he(C(at) + 1, t));
                                                1 === n && A.trigger("frameChange", [K, C(Me)]), n === t && (A.parent().removeClass(le), A.trigger("loaded"))
                                            },
                                            loaded: function(e) {
                                                1 < C(Ze).length || A.css({
                                                    backgroundImage: P(J.substitute(F.path + C(Ue), C))
                                                }).attr({
                                                    src: O(sn)
                                                }), C(wt) && A.attr({
                                                    src: O(sn)
                                                }), C(rt) || T(At, F.velocity || 0), T(We, !1), o = !0
                                            },
                                            prepare: function(e) {
                                                A.css("display", Zt).parent().one(Se, l)
                                            },
                                            opening: function(e) {
                                                if (!F.opening) return A.trigger("openingDone");
                                                var t = (T(Je, !0), T(_t, !C(gt)), F.entry || F.speed),
                                                    n = C(Re),
                                                    a = F.opening;
                                                T(Re, n - t * a), T(et, ge(a * L(xt)))
                                            },
                                            openingDone: function(e) {
                                                var t = (T(nt, !1), T(Je, !1), Kt + M(Je));
                                                ee.unbind(t, z.pool[t]), F.orientable && N(Q).bind(St, function(e) {
                                                    return A.trigger("orient", [U(e).alpha, U(e).beta, U(e).gamma, e]) && e.give
                                                }), 0 < F.delay ? a = setTimeout(function() {
                                                    A.trigger("play")
                                                }, 1e3 * F.delay) : A.trigger("play")
                                            },
                                            play: function(e, t) {
                                                var t = t ? T(gt, t) : C(gt) * H(1, C(ke)),
                                                    n = F.duration,
                                                    a = (n && T(Xt, ge(n * L(xt))), T(ke, t < 0), T(nt, !!t));
                                                T(_t, !a), r()
                                            },
                                            reach: function(e, t, n) {
                                                var a, i, o;
                                                t != C(Me) && (a = C(Pe), T(lt, ge(t / a)), i = T(Ne, C(Me)), t = T(Qe, t), o = T(Ke, J.math.distance(i, t, a)), n = we(n || C(gt)) * H(1, o < 0), A.trigger("play", n))
                                            },
                                            pause: function(e) {
                                                v()
                                            },
                                            stop: function(e) {
                                                var t = T(_t, !0);
                                                T(nt, !t)
                                            },
                                            down: function(e, t, n, a) {
                                                function i(e) {
                                                    return A.trigger("up", [e]) && e.give
                                                }
                                                var o, r;
                                                !F.clickfree && a && a.button !== K && a.button != fn || !F.draggable || (T(qe, C(Me)), o = F.clickfree, T(At, 0), r = o ? C(Ye) : E, b = S(C(st), t, n), v(), Y(), w = 0, N(en, E).addClass(ue), r.bind(Ot + Ht + It, function(e) {
                                                    return A.trigger("pan", [V(e).clientX, V(e).clientY, e]) && e.give
                                                }).bind(Rt + Ht + Lt, i).bind(o ? Ft : Nt, i))
                                            },
                                            up: function(e, t) {
                                                var n = (T(qe, !1), T(ot, !1), F.throwable),
                                                    a = we(x[0] + x[1]) / 60,
                                                    i = T(At, n ? !0 === n ? a : he(n, a) : 0);
                                                d = i ? 1 : 0, v(), Y(), N(en, E).removeClass(ue), (F.clickfree ? C(Ye) : E).unbind($t)
                                            },
                                            pan: function(e, t, n, a) {
                                                if (F.draggable && q) {
                                                    q = !1, v();
                                                    var i, o, r, c, s, u, l, d, f = F.rows,
                                                        p = F.orbital,
                                                        m = !C(ot) && f <= 1 && !p && F.scrollable,
                                                        g = {
                                                            x: t - b.x,
                                                            y: n - b.y
                                                        },
                                                        h = {
                                                            x: we(g.x),
                                                            y: we(g.y)
                                                        };
                                                    if (a && m && h.x < h.y) return a.give = !0;
                                                    (0 < h.x || 0 < h.y) && (a && (a.give = !1), w = ve(h.x, h.y), b = {
                                                        x: t,
                                                        y: n
                                                    }, i = C(st), d = C(De), c = C(Ct), C(Oe) || (o = T(Re, X(c ? n - d.y : t - d.x, C(Ee), i, C(Ge), C(He), C(Ie), c ? n - d.y : t - d.x)), T(ot, C(ot) || C(Me) != C(qe)), (r = _(c ? g.y : g.x || 0)) && T(ke, r < 0)), p && C(je) && (c = T(Ct, we(n - d.y) > we(t - d.x)), d = S(i, t, n)), 1 < f && !C(dt) && (s = C(ut), l = -(u = C(Fe)) * s, T(kt, J.math.envelope(n - d.y, u, s, l, l + s, -1))), o % 1 || F.loops || (d = S(i, t, n)))
                                                }
                                            },
                                            wheel: function(e, t, n) {
                                                var a, i;
                                                t && (c = !0, a = H(a = ge(fe.sqrt(we(t)) / 2), 0 < t), i = .0833 * C(st), S(i), a && T(ke, a < 0), T(At, 0), T(Re, X(a, C(Ee), i, C(Ge), C(He), C(Ie))), n && n.preventDefault(), n && (n.give = !1), v(), A.trigger("up", [n]))
                                            },
                                            orient: function(e, t, n, a, i) {
                                                var o;
                                                q && !s && (f = !0, o = t / 360, fraction = T(Re, +(F.stitched || F.cw ? 1 - o : o).toFixed(2)), q = !1)
                                            },
                                            fractionChange: function(e, t, n) {
                                                var a, i, o;
                                                t === K && (o = 1 + me(n / C(Te)), a = 1 < F.rows, i = F.orbital, T(je, !!i && (o <= i || o >= C(Le) - i + 2)), a && (o += (C(lt) - 1) * C(Pe)), o = T(Me, o))
                                            },
                                            tierChange: function(e, t, n) {
                                                var a, i, o;
                                                t === K && (a = T(lt, pe(be(n, 1, F.rows))), i = C(Pe), o = C(Me) % i || i, o = T(Me, o + a * i - i))
                                            },
                                            rowChange: function(e, t, n) {
                                                t === K && D(kt, K, n, F.rows)
                                            },
                                            frameChange: function(e, t, n) {
                                                var a, i, o, r, c, s, u, l, d, f, p, m, g, h, v, w, y, b, _, Y;
                                                t === K && (this.className = this.className.replace(J.re.frame_klass, de + n), a = C(Pe), i = F.rows, o = F.path, c = ((n - (r = n % a || a)) / a + 1 - 1) / (i - 1), s = C(lt), i ? D(kt, c, s, i) : C(kt), u = D(Re, K, r, a), l = C(Le), F.orbital && C(Ct) && (n = F.inversed ? l + 1 - n : n, n += l), d = C(wt), !(f = C(Ze)).length || d ? (p = C(mt), m = C(zt), g = C(Be), d ? (Y = [Z(-T(yt, pe(be(u, 0, C(bt))) % d)), Z(-(i <= 1 ? 0 : (g + p) * (i - s)))], h = 1 < f.length && f[s - 1], v = J.substitute(o + h, C), h && A.css("backgroundImage").search(v) < 0 && A.css({
                                                    backgroundImage: P(v)
                                                })) : (w = F.horizontal, y = (y = n % l - 1) < 0 ? l - 1 : y, b = (me((n - .1) / l) + (!(1 < i) && !C(ke) && F.directional ? C(ft) : 0)) * ((w ? g : m) + p), _ = y * ((w ? m : g) + p), Y = f.length ? [0, 0] : w ? [Z(-_), Z(-b)] : [Z(-b), Z(-_)]), A.css({
                                                    backgroundPosition: Y.join(Ht)
                                                })) : (C(ct) && $(), C(at) && A.attr({
                                                    src: W(J.substitute(o + f[n - 1], C))
                                                })))
                                            },
                                            "frameChange.reach": function(e, t, n) {
                                                var a;
                                                C(Qe) && t === K && (a = J.math.distance(C(Ne), n, C(Pe)), we(a) >= we(C(Ke)) && (T(Me, T(Qe)), T(Qe, T(Ke, T(Ne, 0))), A.trigger("stop")))
                                            },
                                            "imageChange imagesChange": function(e, t, n) {
                                                A.trigger("preload")
                                            },
                                            "fractionChange.indicator": function(e, t, n) {
                                                var a, i, o, r, c, s;
                                                F.indicator && t === K && (a = F.indicator, i = F.orbital, c = C(i && C(Ct) ? Be : zt), o = i ? C(Le) : F.images.length || C(Pe), r = ge(c / o), s = pe(be(n, 0, c = c - r)), s = !F.cw || C(wt) ? s : c - s, g.$x.css(C(Ct) ? {
                                                    left: 0,
                                                    top: Z(s),
                                                    bottom: xe,
                                                    width: a,
                                                    height: r
                                                } : {
                                                    bottom: 0,
                                                    left: Z(s),
                                                    top: xe,
                                                    width: r,
                                                    height: a
                                                }))
                                            },
                                            "tierChange.indicator": function(e, t, n) {
                                                var a, i, o, r;
                                                1 < F.rows && F.indicator && t === K && (o = C(Be), a = F.indicator, i = ge(o / F.rows), r = pe(n * (o = o - i)), g.$y.css({
                                                    left: 0,
                                                    top: r,
                                                    width: a,
                                                    height: i
                                                }))
                                            },
                                            "setup.annotations": function(e) {
                                                var o = A.parent();
                                                N.each(C(_e), function(e, t) {
                                                    var n = (n = (n = typeof t.node == rn ? N(t.node) : t.node || {}).jquery ? n : N(R(Gt), n)).attr({
                                                            id: e
                                                        }).addClass(se),
                                                        a = t.image ? N(R(nn), t.image) : N(),
                                                        i = t.link ? N("<a/>", t.link).click(function() {
                                                            A.trigger("up.annotations", {
                                                                target: i
                                                            })
                                                        }) : N();
                                                    j(G(e), {
                                                        display: an,
                                                        position: Ut
                                                    }, !0), t.image || t.link && n.append(i), t.link || t.image && n.append(a), t.link && t.image && n.append(i.append(a)), n.appendTo(o)
                                                })
                                            },
                                            "prepare.annotations": function(e) {
                                                N.each(C(_e), function(e, t) {
                                                    N(G(e)).hide()
                                                })
                                            },
                                            "frameChange.annotations": function(e, t, n) {
                                                var m, g, h;
                                                C(at) && t === K && (m = C(zt), g = C(wt), h = C(yt), N.each(C(_e), function(e, t) {
                                                    var n, a, i = N(G(e)),
                                                        o = t.start || 1,
                                                        r = t.end,
                                                        c = c || C(Me),
                                                        s = c - 1,
                                                        u = !!t.at && "+" == t.at[s],
                                                        s = t.at ? s : s - o + 1,
                                                        l = typeof t.x != on ? t.x : t.x[s],
                                                        d = typeof t.y != on ? t.y : t.y[s],
                                                        f = l !== K && d !== K && (t.at ? u : 0 <= s && (!r || s <= r - o));
                                                    g && (n = g - m < l && 0 <= h && h < m, l = l < m && g - m < h ? l + g : l, l = n ? l - g : l, l -= h), C(ct) && (a = C(it), l = l && l * a, d = d && d * a);
                                                    var p = {
                                                        display: f ? Zt : an,
                                                        left: Z(l),
                                                        top: Z(d)
                                                    };
                                                    i.css(p)
                                                }))
                                            },
                                            "up.annotations": function(e, t) {
                                                var n;
                                                10 < w || c || ((n = N(t.target)).is("a") ? n : n.parents("a")).attr("href") && (w = 10)
                                            },
                                            "up.steppable": function(e, t) {
                                                w || c || A.trigger(C(De).x - A.offset().left > .5 * C(zt) ? "stepRight" : "stepLeft")
                                            },
                                            "stepLeft stepRight": function(e) {
                                                v()
                                            },
                                            stepLeft: function(e) {
                                                T(ke, !1), T(Re, C(Re) - C(Te) * C(Ie))
                                            },
                                            stepRight: function(e) {
                                                T(ke, !0), T(Re, C(Re) + C(Te) * C(Ie))
                                            },
                                            stepUp: function(e) {
                                                T(lt, C(lt) - 1)
                                            },
                                            stepDown: function(e) {
                                                T(lt, C(lt) + 1)
                                            },
                                            resize: function(e, t) {
                                                var n, a, i, o, r, c;
                                                C(We) && !t || (n = C(wt), a = C(mt), i = C(Be), o = !C(Ze).length || n, r = F.rows || 1, c = C(Ze).length ? n ? Z(n) + Ht + Z(i) : K : n && Z(n) + Ht + Z((i + a) * r - a) || Z((C(zt) + a) * C(Le) - a) + Ht + Z((i + a) * C(ft) * r * (F.directional ? 2 : 1) - a), A.css({
                                                    height: o ? Z(i) : null,
                                                    backgroundSize: c || null
                                                }), t || A.trigger("imagesChange"))
                                            },
                                            "setup.fu": function(e) {
                                                T(Me, F.frame + (C(lt) - 1) * C(Pe)), A.trigger("preload")
                                            },
                                            "wheel.fu": function() {
                                                c = !1
                                            },
                                            "clean.fu": function() {
                                                A.trigger("teardown")
                                            },
                                            "loaded.fu": function() {
                                                A.trigger("opening")
                                            }
                                        },
                                        pool: {
                                            "tick.reel.preload": function(e) {
                                                var t, n, a, i;
                                                !o && !C(We) || C(pt) || (t = C(zt), n = ye(m.$.css(zt)), a = C(Ze).length || 1, i = pe(1 / a * C(at) * t), m.$.css({
                                                    width: n + (i - n) / 3 + 1
                                                }), C(at) === a && t - 1 < n && (o = !1, m.$.fadeOut(300, function() {
                                                    m.$.css({
                                                        opacity: 1,
                                                        width: 0
                                                    })
                                                })))
                                            },
                                            "tick.reel": function(e) {
                                                if (!C(pt)) {
                                                    var t, n, a, i, o = C(At),
                                                        r = L(xt),
                                                        c = F.monitor;
                                                    if (J.intense || !h()) {
                                                        if (d && (t = o - C(Ae) / r * d, o = T(At, .1 < t ? t : d = s = 0)), c && p.text(C(c)), o && d++, s && s++, _(0), q = !0, s && !o) return u(e);
                                                        if (C(qe)) return u(e, v());
                                                        0 < C(et) || (!F.loops && F.rebound && (s || C(Re) % 1 ? y = 0 : y++, y >= 1e3 * F.rebound / r) && T(ke, !C(ke)), n = C(Ie) * H(1, C(ke)), i = C(Xt), a = (C(nt) && !f && i ? we(C(gt)) + o : o) / L(xt), !(i = (T(Re, C(Re) - a * n), F.duration ? 0 < i && T(Xt, i - 1) : i)) && C(nt) && A.trigger("stop"))
                                                    }
                                                }
                                            },
                                            "tick.reel.opening": function(e) {
                                                var t, n;
                                                C(Je) && (t = (F.entry || F.speed) / L(xt) * (F.cw ? -1 : 1), n = T(et, C(et) - 1), T(Re, C(Re) + t), n || A.trigger("openingDone"))
                                            }
                                        }
                                    },
                                    o = !1,
                                    u = function(e, t) {
                                        return e.stopImmediatePropagation() || t
                                    },
                                    l = function() {
                                        A.trigger("setup")
                                    },
                                    d = 0,
                                    r = function() {
                                        return s = 0
                                    },
                                    v = function() {
                                        return clearTimeout(a), ee.unbind(Kt + M(Je), z.pool[Kt + M(Je)]), T(et, 0), T(rt, !0), s = -F.timeout * L(xt)
                                    },
                                    w = 0,
                                    c = !1,
                                    f = !1,
                                    p = N(),
                                    m = function() {
                                        return j(Ht + M(re), {
                                            position: Ut,
                                            left: 0,
                                            bottom: 0,
                                            height: F.preloader,
                                            overflow: Ve,
                                            backgroundColor: "#000"
                                        }), m.$ = N(R(Gt), {
                                            class: re
                                        })
                                    },
                                    g = function(e) {
                                        return j(Ht + M(oe) + M(e), {
                                            position: Ut,
                                            width: 0,
                                            height: 0,
                                            overflow: Ve,
                                            backgroundColor: "#000"
                                        }), g["$" + e] = N(R(Gt), {
                                            class: oe + Ht + e
                                        })
                                    },
                                    j = function(e, t, n) {
                                        var a, i = n ? Bt : C(vt),
                                            e = e.replace(/^/, i).replace(Vt, Vt + i);
                                        return j.rules.push(e + (a = [], N.each(t, function(e, t) {
                                            a.push(e.replace(/([A-Z])/g, "-$1").toLowerCase() + ":" + Z(t) + ";")
                                        }), "{" + a.join(Bt) + "}")) && t
                                    },
                                    h = function() {
                                        var e = C(Be),
                                            t = C(zt),
                                            n = A[0].getBoundingClientRect();
                                        return n.top < -e || n.left < -t || n.right > t + N(Q).width() || n.bottom > e + N(Q).height()
                                    },
                                    y = 0,
                                    b = {
                                        x: 0,
                                        y: 0
                                    },
                                    _ = function(e) {
                                        return x.push(e) && x.shift() && e
                                    },
                                    Y = function() {
                                        return x = [0, 0]
                                    },
                                    x = Y(),
                                    X = F.graph || J.math[F.loops ? "hatch" : "envelope"],
                                    k = (J.normal, function() {
                                        clearTimeout(i), i = setTimeout($, J.resize_gauge)
                                    }),
                                    $ = function() {
                                        var e, n;
                                        A.width() != C(zt) && (e = C(Tt), n = T(it, A.width() / e.width), N.each(e, function(e, t) {
                                            T(e, pe(t * n))
                                        }), A.trigger("resize"))
                                    },
                                    S = function(e, t, n) {
                                        var a = T(Ee, C(Re)),
                                            i = (T(Fe, C(kt)), F.loops);
                                        return T(Ge, i ? 0 : -a * e), T(He, i ? e : e - a * e), t !== K && T(De, {
                                            x: t,
                                            y: n
                                        }) || K
                                    },
                                    q = !0,
                                    D = function(e, t, n, a) {
                                        if (a) {
                                            var i = C(e) || 0,
                                                o = t !== K ? t : (n - 1) / (a - 1),
                                                o = e != Re ? o : he(o, .9999);
                                            return t = +we(i - o).toFixed(8) >= +(1 / (a - 1)).toFixed(8) ? T(e, o) : t || i
                                        }
                                    },
                                    E = ee;
                                try {
                                    ee[0] != top.document && (E = ee.add(top.document))
                                } catch (e) {}
                                top === self ? N() : N("iframe", E.last()).each(function() {
                                    try {
                                        if (N(this).contents().find(Jt).html() == N(Jt).html()) return N(this) && !1
                                    } catch (e) {}
                                }), j.rules = [], z.setup()
                            }), l = l || function e() {
                                var t = +new Date,
                                    n = L(xt);
                                return l = n ? (ee.trigger(Kt), J.cost = (+new Date + J.cost - t) / 2, setTimeout(e, ve(4, 1e3 / n - J.cost))) : null
                            }(), N(I)
                        },
                        unreel: function() {
                            return this.trigger("teardown")
                        }
                    },
                    re: {
                        image: /^(.*)\.(jpg|jpeg|png|gif)\??.*$/i,
                        ua: [/(msie|opera|firefox|chrome|safari)[ \/:]([\d.]+)/i, /(webkit)\/([\d.]+)/i, /(mozilla)\/([\d.]+)/i],
                        array: / *, */,
                        lazy_agent: /\(iphone|ipod|android|fennec|blackberry/i,
                        frame_klass: /frame-\d+/,
                        substitution: /(@([A-Z]))/g,
                        no_match: /^(undefined|)$/,
                        sequence: /(^[^#|]*([#]+)[^#|]*)($|[|]([0-9]+)\.\.([0-9]+))($|[|]([0-9]+)$)/
                    },
                    cdn: "http://code.vostrel.net/",
                    math: {
                        envelope: function(e, t, n, a, i, o, r) {
                            return t + c(a, i, -e * o) / n
                        },
                        hatch: function(e, t, n, a, i, o, r) {
                            var c = t + -(e = (e < a ? i : 0) + e % i) * o / n;
                            return c - me(c)
                        },
                        interpolate: function(e, t, n) {
                            return t + e * (n - t)
                        },
                        distance: function(e, t, n) {
                            var a = n / 2,
                                i = t - e;
                            return i < -a ? i + n : a < i ? i - n : i
                        }
                    },
                    preload: {
                        fidelity: function(e, f, t) {
                            function n(e, t, n) {
                                function a(e) {
                                    for (; !(1 <= e && e <= c);) e += e < 1 ? +c : -c;
                                    return p[n + e] || (p[n + e] = !!i.push(e))
                                }
                                if (!e.length) return [];
                                for (var i = [], o = 4 * t, r = f.frame, c = e.length, s = !0, u = c / o, l = 0; l < o; l++) a(r + pe(l * u));
                                for (; 1 < u;)
                                    for (var l = 0, d = i.length, u = u / 2, s = !s; l < d; l++) a(i[l] + (s ? 1 : -1) * pe(u));
                                for (l = 0; l <= c; l++) a(l);
                                for (l = 0; l < i.length; l++) i[l] = e[i[l] - 1];
                                return i
                            }
                            var a = f.orbital,
                                i = a ? 2 : f.rows || 1,
                                o = t(a ? Le : Pe),
                                r = (f.row - 1) * o,
                                c = (new Array).concat(e),
                                p = new Array(e.length + 1);
                            return n(i < 2 ? [] : c.slice(r, r + o), 1, r).concat(n(c, i, 0))
                        },
                        linear: function(e, t, n) {
                            return e
                        }
                    },
                    substitute: function(e, a) {
                        return e.replace(J.re.substitution, function(e, t, n) {
                            return "function" == typeof J.substitutes[n] ? J.substitutes[n](a) : h[n] ? a(h[n]) : t
                        })
                    },
                    substitutes: {
                        T: function(e) {
                            return +new Date
                        }
                    },
                    normal: {
                        fraction: function(e, t) {
                            return null === e ? e : t[tt].loops ? e - me(e) : c(0, 1, e)
                        },
                        tier: function(e, t) {
                            return null === e ? e : c(0, 1, e)
                        },
                        row: function(e, t) {
                            return null === e ? e : pe(c(1, t[tt].rows, e))
                        },
                        frame: function(e, t) {
                            if (null === e) return e;
                            var n = t[tt],
                                a = t[Pe] * (n.orbital ? 2 : n.rows || 1),
                                i = pe(n.loops ? e % a || a : c(1, a, e));
                            return i < 0 ? i + a : i
                        },
                        images: function(e, t) {
                            var n = J.re.sequence.exec(e);
                            return n ? J.sequence(n, t[tt]) : e
                        }
                    },
                    sequence: function(e, t) {
                        if (e.length <= 1) return t.images;
                        for (var n = [], a = t.orbital, i = e[1], o = e[2], r = e[4], r = J.re.no_match.test(r + Bt) ? 1 : +r, c = a ? 2 : t.rows || 1, s = a ? t.footage : t.stitched ? 1 : t.frames, u = +(e[5] || c * s) - r, l = +e[7] || 1, d = 0; d <= u;) n.push(i.replace(o, f(r + d + Bt, o.length, "0"))), d += l;
                        return n
                    },
                    instances: N(),
                    leader: L,
                    resize_gauge: 300,
                    concurrent_requests: 4,
                    cost: 0
                },
                ee = N(e),
                a = navigator.userAgent,
                i = J.re.ua[0].exec(a) || J.re.ua[1].exec(a) || J.re.ua[2].exec(a),
                o = +i[2].split(".").slice(0, 2).join("."),
                d = "MSIE" == i[1],
                p = !(d && o < 8),
                te = !(d && o < 9),
                ne = "reel",
                ae = ne + "-overlay",
                ie = ne + "-cache",
                oe = ne + "-indicator",
                re = ne + "-preloader",
                ce = ne + "-monitor",
                se = ne + "-annotation",
                ue = ne + "-panning",
                le = ne + "-loading",
                de = "frame-",
                fe = Math,
                pe = fe.round,
                me = fe.floor,
                ge = fe.ceil,
                he = fe.min,
                ve = fe.max,
                we = fe.abs,
                ye = parseInt,
                be = J.math.interpolate,
                _e = "annotations",
                Ye = "area",
                xe = "auto",
                Xe = "backup",
                ke = "backwards",
                Te = "bit",
                Ae = "brake",
                Ce = "cache",
                ze = Ce + "d",
                je = "center",
                $e = "class",
                Se = "click",
                qe = Se + "ed",
                De = qe + "_location",
                Ee = qe + "_on",
                Fe = qe + "_tier",
                Ie = "cwish",
                Ne = "departure",
                Qe = "destination",
                Ke = "distance",
                Le = "footage",
                Re = "fraction",
                Me = "frame",
                Oe = "framelock",
                Pe = "frames",
                Be = "height",
                He = "hi",
                Ve = "hidden",
                Ue = "image",
                Ze = "images",
                Ge = "lo",
                We = "loading",
                Je = "opening",
                et = Je + "_ticks",
                tt = "options",
                nt = "playing",
                at = "preloaded",
                it = "ratio",
                ot = "reeling",
                rt = "reeled",
                ct = "responsive",
                st = "revolution",
                ut = "revolution_y",
                lt = "row",
                dt = "rowlock",
                ft = "rows",
                pt = "shy",
                mt = "spacing",
                gt = "speed",
                ht = "src",
                vt = "stage",
                wt = "stitched",
                yt = wt + "_shift",
                bt = wt + "_travel",
                _t = "stopped",
                Yt = "style",
                xt = "tempo",
                Xt = "ticks",
                kt = "tier",
                Tt = "truescale",
                At = "velocity",
                Ct = "vertical",
                zt = "width",
                jt = M(ne),
                $t = ".pan" + jt,
                St = "deviceorientation" + jt,
                qt = "dragstart" + jt,
                Dt = "mousedown" + jt,
                Et = "mouseenter" + jt,
                Ft = "mouseleave" + $t,
                It = "mousemove" + $t,
                Nt = "mouseup" + $t,
                Qt = "mousewheel" + jt,
                Kt = "tick" + jt,
                Lt = "touchcancel" + $t,
                Rt = "touchend" + $t,
                Mt = "touchstart" + jt,
                Ot = "touchmove" + $t,
                Pt = "resize" + jt,
                Bt = "",
                Ht = " ",
                Vt = ",",
                Ut = "absolute",
                Zt = "block",
                m = "@CDN@",
                Gt = "div",
                Wt = "hand",
                Jt = "head",
                en = "html",
                tn = "id",
                nn = "img",
                g = "jquery." + ne,
                an = "none",
                on = "object",
                rn = "string",
                cn = [zt, Be, mt, st, ut, wt, yt, bt],
                h = {
                    W: zt,
                    H: Be
                },
                sn = p ? "data:image/gif;base64,R0lGODlhCAAIAIAAAAAAAAAAACH5BAEAAAAALAAAAAAIAAgAAAIHhI+py+1dAAA7" : m + "blank.gif",
                un = P(m + g + ".cur") + Vt + "move",
                ln = P(m + g + "-drag.cur") + Vt + "move",
                dn = P(m + g + "-drag-down.cur") + Vt + "move",
                fn = (J.lazy = J.re.lazy_agent.test(a), d && o < 9 ? 1 : 0),
                v = N.cleanData;
            return N.cleanData = function(e) {
                return N(e).each(function() {
                    N(this).triggerHandler("clean")
                }), v.apply(this, arguments)
            }, N.extend(N.fn, J.fn) && N(J.scan), J
        }
    }(jQuery, window, document)
});
var scrollme = function(a) {
    var X = {},
        e = a(document),
        t = a(window);
    return X.body_height = 0, X.viewport_height = 0, X.viewport_top = 0, X.viewport_bottom = 0, X.viewport_top_previous = -1, X.elements = [], X.elements_in_view = [], X.property_defaults = {
        opacity: 1,
        translatex: 0,
        translatey: 0,
        translatez: 0,
        rotatex: 0,
        rotatey: 0,
        rotatez: 0,
        scale: 1,
        scalex: 1,
        scaley: 1,
        scalez: 1
    }, X.scrollme_selector = ".scrollme", X.animateme_selector = ".animateme", X.update_interval = 10, X.easing_functions = {
        linear: function(e) {
            return e
        },
        easeout: function(e) {
            return e * e * e
        },
        easein: function(e) {
            return 1 - (e = 1 - e) * e * e
        },
        easeinout: function(e) {
            return e < .5 ? 4 * e * e * e : 1 - 4 * (e = 1 - e) * e * e
        }
    }, X.init_events = ["ready", "page:load", "page:change"], X.init_if = function() {
        return !0
    }, X.init = function() {
        return !!X.init_if() && (X.init_elements(), X.on_resize(), t.on("resize orientationchange", function() {
            X.on_resize()
        }), t.load(function() {
            setTimeout(function() {
                X.on_resize()
            }, 100)
        }), setInterval(X.update, X.update_interval), !0)
    }, X.init_elements = function() {
        a(X.scrollme_selector).each(function() {
        	console.log('Run Scrollme');
            var e = {};
            e.element = a(this);
            var n = [];
            a(this).find(X.animateme_selector).addBack(X.animateme_selector).each(function() {
                var e = {};
                e.element = a(this), e.when = e.element.data("when"), e.from = e.element.data("from"), e.to = e.element.data("to"), e.element.is("[data-crop]") ? e.crop = e.element.data("crop") : e.crop = !0, e.element.is("[data-easing]") ? e.easing = X.easing_functions[e.element.data("easing")] : e.easing = X.easing_functions.easeout;
                var t = {};
                e.element.is("[data-opacity]") && (t.opacity = e.element.data("opacity")), e.element.is("[data-translatex]") && (t.translatex = e.element.data("translatex")), e.element.is("[data-translatey]") && (t.translatey = e.element.data("translatey")), e.element.is("[data-translatez]") && (t.translatez = e.element.data("translatez")), e.element.is("[data-rotatex]") && (t.rotatex = e.element.data("rotatex")), e.element.is("[data-rotatey]") && (t.rotatey = e.element.data("rotatey")), e.element.is("[data-rotatez]") && (t.rotatez = e.element.data("rotatez")), e.element.is("[data-scale]") && (t.scale = e.element.data("scale")), e.element.is("[data-scalex]") && (t.scalex = e.element.data("scalex")), e.element.is("[data-scaley]") && (t.scaley = e.element.data("scaley")), e.element.is("[data-scalez]") && (t.scalez = e.element.data("scalez")), e.properties = t, n.push(e)
            }), e.effects = n, X.elements.push(e)
        })
    }, X.update = function() {
        window.requestAnimationFrame(function() {
            X.update_viewport_position(), X.viewport_top_previous != X.viewport_top && (X.update_elements_in_view(), X.animate()), X.viewport_top_previous = X.viewport_top
        })
    }, X.animate = function() {
        for (var e = X.elements_in_view.length, t = 0; t < e; t++)
            for (var n = X.elements_in_view[t], a = n.effects.length, i = 0; i < a; i++) {
                var o = n.effects[i];
                switch (o.when) {
                    case "view":
                    case "span":
                        var r = n.top - X.viewport_height,
                            c = n.bottom;
                        break;
                    case "exit":
                        r = n.bottom - X.viewport_height, c = n.bottom;
                        break;
                    default:
                        r = n.top - X.viewport_height, c = n.top
                }
                o.crop && (r < 0 && (r = 0), c > X.body_height - X.viewport_height && (c = X.body_height - X.viewport_height));
                var s = (X.viewport_top - r) / (c - r),
                    u = o.from,
                    l = o.to,
                    d = (s - u) / (l - u),
                    f = o.easing(d),
                    p = X.animate_value(s, f, u, l, o, "opacity"),
                    m = X.animate_value(s, f, u, l, o, "translatey"),
                    g = X.animate_value(s, f, u, l, o, "translatex"),
                    h = X.animate_value(s, f, u, l, o, "translatez"),
                    v = X.animate_value(s, f, u, l, o, "rotatex"),
                    w = X.animate_value(s, f, u, l, o, "rotatey"),
                    y = X.animate_value(s, f, u, l, o, "rotatez"),
                    b = X.animate_value(s, f, u, l, o, "scale"),
                    _ = X.animate_value(s, f, u, l, o, "scalex"),
                    Y = X.animate_value(s, f, u, l, o, "scaley"),
                    x = X.animate_value(s, f, u, l, o, "scalez");
                "scale" in o.properties && (x = Y = _ = b), o.element.css({
                    opacity: p,
                    transform: "translate3d( " + g + "px , " + m + "px , " + h + "px ) rotateX( " + v + "deg ) rotateY( " + w + "deg ) rotateZ( " + y + "deg ) scale3d( " + _ + " , " + Y + " , " + x + " )"
                })
            }
    }, X.animate_value = function(e, t, n, a, i, o) {
        var r = X.property_defaults[o];
        if (!(o in i.properties)) return r;
        var c = i.properties[o],
            s = n < a;
        if (e < n && s) return r;
        if (a < e && s) return c;
        if (n < e && !s) return r;
        if (e < a && !s) return c;
        var u = r + t * (c - r);
        switch (o) {
            case "opacity":
                u = u.toFixed(2);
                break;
            case "translatex":
            case "translatey":
            case "translatez":
                u = u.toFixed(0);
                break;
            case "rotatex":
            case "rotatey":
            case "rotatez":
                u = u.toFixed(1);
                break;
            case "scale":
                u = u.toFixed(3)
        }
        return u
    }, X.update_viewport_position = function() {
        X.viewport_top = t.scrollTop(), X.viewport_bottom = X.viewport_top + X.viewport_height
    }, X.update_elements_in_view = function() {
        X.elements_in_view = [];
        for (var e = X.elements.length, t = 0; t < e; t++) X.elements[t].top < X.viewport_bottom && X.elements[t].bottom > X.viewport_top && X.elements_in_view.push(X.elements[t])
    }, X.on_resize = function() {
        X.update_viewport(), X.update_element_heights(), X.update_viewport_position(), X.update_elements_in_view(), X.animate()
    }, X.update_viewport = function() {
        X.body_height = e.height(), X.viewport_height = t.height()
    }, X.update_element_heights = function() {
        for (var e = X.elements.length, t = 0; t < e; t++) {
            var n = X.elements[t].element.outerHeight(),
                a = X.elements[t].element.offset();
            X.elements[t].height = n, X.elements[t].top = a.top, X.elements[t].bottom = a.top + n
        }
    }, e.on(X.init_events.join(" "), function() {
        X.init()
    }), X
}(jQuery);
$(document).ready(function() {
    function e(e) {
        var t;
        e.preventDefault(), $(window).scrollTop() >= a ? (i.addClass("navbar-fixed-top"), $("body").css("padding-top", i.outerHeight(!0))) : (i.removeClass("navbar-fixed-top"), $("body").css("padding-top", 0)), (d = window.pageYOffset) < 700 && (-1 != navigator.userAgent.indexOf("Chrome") ? (l && (u.pause(), l = !1), t = (d = window.pageYOffset) > o ? "down" : "up", t = d == o ? "equal" : t, o = d, "equal" != t && function(e) {
            return f = f.then(e)
        }(function() {
            return e = d - 40, a = t, new Promise(function(t) {
                var n = s - s / r * (e = (e = r < e ? r : e) < 0 ? 0 : e);
                requestAnimationFrame(function e() {
                    if (o = window.pageYOffset, u.seeking) requestAnimationFrame(e);
                    else {
                        if ("down" == a) {
                            if (u.currentTime -= c, u.currentTime <= n || u.currentTime <= 0) return t();
                            a = "down"
                        } else {
                            if ("up" != a) return t();
                            if (u.currentTime += c, u.currentTime >= n || u.currentTime >= s) return t();
                            a = "up"
                        }
                        requestAnimationFrame(e)
                    }
                })
            });
            var e, a
        }).then(function() {
            o = window.pageYOffset
        })) : 50 <= d && window.requestAnimationFrame(n))
    }

    function n() {
        u.currentTime = s - s / (r - t) * (d - t)
    }
    var a = $(".navbar-first").outerHeight(!0),
        i = $(".navbar-second"),
        o = window.pageYOffset,
        r = 260,
        t = 50,
        c = .15,
        s = 2.0666,
        u = document.getElementById("hero-video"),
        l = !0,
        d = 0;
    if (u != null) {
        -1 != navigator.userAgent.indexOf("Chrome") ? $(window).on("scroll", $.throttle(10, e)) : $(window).on("scroll", e)
    };
    var f = Promise.resolve();
    $(".nav a").on("click", function(e) {
        var t;
        "" !== this.hash && (e.preventDefault(), t = this.hash, $("html, body").animate({
            scrollTop: $(t).offset().top
        }, 1e3, function() {
            window.location.hash = t
        }))
    }), $("#feature-reveal").twentytwenty();
    var p, m, g, h, v, w = $("#sets-carousel");
    w.owlCarousel({
        center: !0,
        dots: !1,
        items: 1,
        loop: !0,
        margin: 10,
        responsive: {
            767: {
                items: 2
            }
        }
    }), $(".carousel-back").click(function() {
        w.trigger("prev.owl.carousel")
    }), $(".carousel-forward").click(function() {
        w.trigger("next.owl.carousel")
    }), $("#filling").fitVids(), window.screen.width < 768 && $(".stat-block.sb1").length>0 && $(".stat-block.sb12").length>0 && $(".stat-block.sb3").length>0 && ((p = $(".top.animateme")[0]).dataset.translatey = "20", p.dataset.from = "0.4", p.dataset.to = "0.2", (m = $(".bot.animateme")[0]).dataset.translatey = "-15", m.dataset.from = "0.4", m.dataset.to = "0.2", (g = $(".stat-block.sb1")[0]).dataset.translatey = "-50", g.dataset.opacity = "0", g.dataset.from = "0.4", g.dataset.to = "0.2", (h = $(".stat-block.sb2")[0]).dataset.translatey = "-50", h.dataset.opacity = "0", h.dataset.from = "0.43", h.dataset.to = "0.23", (v = $(".stat-block.sb3")[0]).dataset.translatey = "-50", v.dataset.opacity = "0", v.dataset.from = "0.46", v.dataset.to = "0.26");
    var y = $(".navbar-collapse");
    y.on("click", "a:not([data-toggle])", null, function() {
        y.collapse("hide")
    }), $(".swatch-popup").magnificPopup({
        type: "image",
        closeBtnInside: !1,
        gallery: {
            enabled: !0
        }
    }), $(".iframe-popup").magnificPopup({
        type: "iframe",
        closeBtnInside: !1
    }), $.ajax({
        type: "GET",
        dataType: "json",
        url: "https://graph.facebook.com/ambientlounge/?fields=fan_count&access_token=133219273933374|VRedlipjgEwKzF4a3hKMfzTqpFg",
        success: function(e) {
            var t = e.fan_count;
            $(".social-tip").html(t.toLocaleString())
        }
    })
}), $(window).load(function() {
    $("#feature-reveal").twentytwenty()
});